<template>
  <div class="test">
    <!-- Модальное окно загрузки материалов -->
    <transition name="fadeFast">
      <AddFiles
        v-if="taDownloadMaterials"
        :limitation="[]"
        @addFile="addFile"
        @closeModal="closeDownloadMaterials"
      ></AddFiles>
    </transition>

    <div class="header_breadcrumb">
      <Breadcrumbs :breadcrumbs="breadcrumbs"></Breadcrumbs>

      <div class="delete_button"
        @click="deleteTest()"
      >
        Удалить тест
      </div>
    </div>

    <div class="test_component">
      <div class="container">
        <div class="task"
             :id="'question_' + question.id"
             v-for="(question, i) in content"
             :key="'ta_question_' + i"
        >
          <div class="task_header">
            <div class="header_title">
              {{(i + 1) + ' Вопрос'}}
            </div>

            <div class="header_buttons">
              <div class="header_button button_close"
                   @click="questionDelete(i)"
              >
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5001 6.5L11.9995 11L7.49987 6.5L6 8L10.4996 12.5L6 17L7.49987 18.5L11.9995 14L16.5001 18.5L18 17L13.5004 12.5L18 8L16.5001 6.5Z" fill="#FF6597"/>
                </svg>
              </div>
              <div class="header_button button_move">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 6.5H20V8.5H4V6.5ZM4 11.5H20V13.5H4V11.5ZM4 16.5H20V18.5H4V16.5Z" fill="#AEBCD6"/>
                </svg>
              </div>
            </div>
          </div>

          <div class="task_border"></div>

          <div class="task_main">
            <div class="task_block">
              <div class="task_row">
                <div class="task_elem">
                  <div class="elem_title">Вид задания*</div>
                  <div class="elem_input"
                       :class="'elem_input_QuestionType_' + i"
                       @click="showModalChoiceQuestionType($event, i)"
                  >
                    <div class="input_block">
                      <div class="input_text">

                        {{listOfType[question.type].title}}
                      </div>
                    </div>

                    <div class="input_image"
                         :class="(question.showModalQuestionType)?('input_image__active'):('')"
                    >
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.9353 8.51953L11 12.4548L7.06478 8.51953L5.76862 9.8157L11 15.0471L16.2314 9.8157L14.9353 8.51953Z" fill="#C5C5C9"/>
                      </svg>
                    </div>

                    <transition name="fadeFast">
                      <div class="input_popup"
                           v-clickOutside="(e) => closeModalQuestionType(e, i)"
                           v-if="question.showModalQuestionType"
                      >
                        <div class="popup_element"
                             :class="(question.type === type.id)?('popup_element__active'):('')"
                             v-for="(type, j) in listOfType"
                             :key="'type_list_' + i + '_' + j"
                             @click="setTypeQuestion(i, type.id)"
                        >
                          {{type.title}}
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>

                <div class="task_elem">
                  <div class="elem_title">Прикрепленные материалы</div>
                  <div class="elem_input"
                       @click="openLoadFilesModal($event, i)"
                  >
                    <div class="input_block">
                      <div class="input_placeholder"
                           v-if="question.downloadMaterials.length === 0"
                      >
                        Выберите материалы
                      </div>

                      <div class="input_files"
                           v-else
                      >
                        <div class="input_file input_file__check_class input_file__download"
                             v-for="(file, k) in question.downloadMaterials"
                             :key="'ta_question_file_loaded_' + i + '_' + k"
                             @click="downloadFile(file, $event)"
                        >
                          <div class="file_title">{{file.data.name}}</div>
                          <div class="file_delete"
                               @click="deleteLoadFiles(i, k)"
                          >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.0003 1.66602C5.40533 1.66602 1.66699 5.40435 1.66699 9.99935C1.66699 14.5943 5.40533 18.3327 10.0003 18.3327C14.5953 18.3327 18.3337 14.5943 18.3337 9.99935C18.3337 5.40435 14.5953 1.66602 10.0003 1.66602ZM13.5062 12.3268L12.3278 13.5052L10.0003 11.1777L7.67283 13.5052L6.49449 12.3268L8.82199 9.99935L6.49449 7.67185L7.67283 6.49352L10.0003 8.82102L12.3278 6.49352L13.5062 7.67185L11.1787 9.99935L13.5062 12.3268Z" fill="white"/>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="input_image">
                      <div class="input_svg">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.2754 7.95732C18.2653 7.92798 18.2571 7.89957 18.2452 7.87115C18.2003 7.77398 18.1443 7.6814 18.0655 7.60257L12.5655 2.10257C12.4867 2.02373 12.3941 1.96782 12.2969 1.9229C12.2694 1.91007 12.2401 1.90273 12.2108 1.89265C12.1338 1.86698 12.0549 1.85048 11.9733 1.8459C11.9532 1.84407 11.9358 1.83398 11.9165 1.83398H5.49984C4.48875 1.83398 3.6665 2.65623 3.6665 3.66732V18.334C3.6665 19.3451 4.48875 20.1673 5.49984 20.1673H16.4998C17.5109 20.1673 18.3332 19.3451 18.3332 18.334V8.25065C18.3332 8.2314 18.3231 8.21398 18.3213 8.19382C18.3167 8.11315 18.3011 8.03432 18.2754 7.95732ZM15.2037 7.33398H12.8332V4.96348L15.2037 7.33398ZM5.49984 18.334V3.66732H10.9998V8.25065C10.9998 8.75757 11.4096 9.16732 11.9165 9.16732H16.4998L16.5017 18.334H5.49984Z" fill="#C5C5C9"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Вопрос -->
            <div class="task_block">
              <div class="task_elem"
                   :key="'task_elem_' + question.keyEditor"
              >
                <div class="elem_title">Вопрос*</div>

                <Editor v-if="(question.type !== 3) && (question.type !== 5)"
                        :content="question.question"
                        :idEditor="'ta_editor_question_' + i"
                        :typeEditor="0"
                        :localStore="{
                           id: question.id,
                           i: i,
                           nameUpdatedItem: 'question',
                           field: 'text',
                        }"
                        @onBlur="applyChanges"
                        @inputContent="parseHTMLToText"
                />

                <Editor v-else
                        :content="question.question"
                        :inputList="question.inputsContent"
                        :idEditor="question.id + '_' + question.typePoint"
                        :typeEditor="(question.type === 3)?(1):(2)"
                        :typeInputAnswer="question.assessmentTechniqueActive.id"
                        :localStore="{
                           id: question.id,
                           i: i,
                           field: 'text',
                           type: question.type
                        }"
                        @onBlur="applyChanges"
                        @inputContent="parseHTMLToText"
                        @updateField="updateFieldOmissions"
                        @addNewField="addNewField"
                        @deleteField="deleteField"
                        @addInput="addInput"
                        @removeInput="removeInput"
                        @updateSelectedAnswer="updateSelectedAnswer"
                />
              </div>
            </div>

            <!-- Правильные ответы и техника оценивания для вопроса типа 2 -->
            <div class="task_block"
                 v-if="question.type === 2"
            >
              <div class="task_elem">
                <div class="elem_title">Правильные ответы*</div>
                <div class="elem_input elem_input__answer"

                >
                  <div class="input_block">

                    <div class="input_answer"
                         v-for="(answer, j) in question.inputAnswers"
                         :key="'input_answer_' + i + '_' + j"
                    >
                      <div class="answer_text">
                        {{answer.text}}
                      </div>

                      <div class="answer_delete"
                        @click="answerDelete(i, j)"
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.99935 1.66699C5.40435 1.66699 1.66602 5.40533 1.66602 10.0003C1.66602 14.5953 5.40435 18.3337 9.99935 18.3337C14.5943 18.3337 18.3327 14.5953 18.3327 10.0003C18.3327 5.40533 14.5943 1.66699 9.99935 1.66699ZM13.5052 12.3278L12.3268 13.5062L9.99935 11.1787L7.67185 13.5062L6.49352 12.3278L8.82102 10.0003L6.49352 7.67283L7.67185 6.49449L9.99935 8.82199L12.3268 6.49449L13.5052 7.67283L11.1777 10.0003L13.5052 12.3278Z" fill="white"/>
                        </svg>
                      </div>
                    </div>
                    
                    <div class="input_answerInput"
                         v-if="question.showInputRightAnswer"
                    >
                      <input type="text"
                             :id="'inputRightAnswer_' + i"
                             class="inputRightAnswer"
                             placeholder="Введите правильный ответ"
                             v-model="question.inputRightAnswer"
                      >
                    </div>

                  </div>

                  <div class="input_image">
                    <transition name="fadeFast" mode="out-in">
                      <div class="input_svg"
                           v-if="!question.showInputRightAnswer"
                           @click="addInputField(i)"
                      >
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 4.58398V17.4173" stroke="#C5C5C9" stroke-width="2" stroke-linejoin="round"/>
                          <path d="M4.58301 11H17.4163" stroke="#C5C5C9" stroke-width="2" stroke-linejoin="round"/>
                        </svg>
                      </div>

                      <div class="input_svg"
                           @click="addRightAnswer(i)"
                           v-else
                      >
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.98272 13.1018L6.05694 10.1761L5.96413 10.0833L5.87133 10.1761L4.57516 11.4722L4.48235 11.565L4.57516 11.6579L8.88991 15.9726L8.98272 16.0654L9.07553 15.9726L17.9736 7.07452L18.0664 6.98171L17.9736 6.88891L16.6774 5.59274L16.5846 5.49993L16.4918 5.59274L8.98272 13.1018Z" fill="#C5C5C9" stroke="#C5C5C9" stroke-width="0.2625"/>
                        </svg>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>

            <!-- Правильные ответы и техника оценивания для вопроса типа 2 -->
            <div class="task_block"
                 v-if="question.type === 2"
            >
              <div class="task_elem">
                <div class="elem_title">Техника оценивания</div>
                <div class="elem_input"
                     :class="'elem_input_assessment_technique_' + i"
                     @click="showModalChoiceAssessmentTechnique($event, i)"
                >
                  <div class="input_block">
                    <div class="input_text">
                      <div class="input_text">{{question.assessmentTechniqueActive.title}}</div>
                    </div>
                  </div>

                  <div class="input_image"
                       :class="(question.showModalAssessmentTechnique)?('input_image__active'):('')"
                  >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.9353 8.51953L11 12.4548L7.06478 8.51953L5.76862 9.8157L11 15.0471L16.2314 9.8157L14.9353 8.51953Z" fill="#C5C5C9"/>
                    </svg>
                  </div>

                  <transition name="fadeFast">
                    <div class="input_popup"
                         v-if="question.showModalAssessmentTechnique"
                         v-clickOutside="(e) => closeModalAssessmentTechnique(e, i)"
                    >
                      <div class="popup_element"
                           :class="(elem.id === question.assessmentTechniqueActive.id)?('popup_element__active'):('')"
                           v-for="(elem, k) in assessmentTechnique"
                           :key="'ta_question_assessmentTechnique_loaded_' + i + '_' + k"
                           @click="setAssessmentTechnique(i, k)"
                      >
                        {{elem.title}}
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <!-- Варианты ответов в пропусках для вопроса типа 5 -->
            <div class="task_block"
                 v-else-if="question.type === 5"
            >
              <div class="task_elem">
                <div class="elem_title">Варианты ответов в пропусках</div>
                <div class="elem_input"
                     :class="'elem_input_answer_options_' + i"
                     @click="showModalChoiceAssessmentTechnique($event, i)"
                >
                  <div class="input_block">
                    <div class="input_text">
                      <div class="input_text">{{question.assessmentTechniqueActive.title}}</div>
                    </div>
                  </div>

                  <div class="input_image"
                       :class="(question.showModalAssessmentTechnique)?('input_image__active'):('')"
                  >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.9353 8.51953L11 12.4548L7.06478 8.51953L5.76862 9.8157L11 15.0471L16.2314 9.8157L14.9353 8.51953Z" fill="#C5C5C9"/>
                    </svg>
                  </div>

                  <transition name="fadeFast">
                    <div class="input_popup"
                         v-if="question.showModalAssessmentTechnique"
                         v-clickOutside="(e) => closeModalAssessmentTechnique(e, i)"
                    >
                      <div class="popup_element"
                           :class="(elem.id === question.assessmentTechniqueActive.id)?('popup_element__active'):('')"
                           v-for="(elem, k) in answerOptions"
                           :key="'ta_question_answerOptions_loaded_' + i + '_' + k"
                           @click="setAnswerOptions(i, k)"
                      >
                        {{elem.title}}
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <!-- Пояснение к вопросу -->
            <div class="task_block">
              <div class="task_elem">
                <div class="elem_title">Пояснение к вопросу</div>

                <Editor :content="question.explanationToQuestion"
                        :idEditor="'ta_editor_explanation_' + i"
                        :typeEditor="0"
                        :localStore="{
                           id: question.id,
                           i: i,
                           nameUpdatedItem: 'explanationToQuestion',
                           field: 'comment',
                        }"
                        @onBlur="applyChanges"
                />
              </div>
            </div>

            <!--ratio checkbox-->
            <div class="task_block"
                 v-if="question.type === 0"
            >
              <div class="task_elem">
                <div class="elem_title">Варианты ответа*</div>

                <div class="task_list">
                  <div class="list_elem"
                       :class="(question.pickedAnswers === elem.id)?('list_elem__active'):('')"
                       v-for="(elem, k) in question.answers"
                  >
                    <div class="elem_block">
                      <input type="radio"
                             class="custom-radio"
                             :id="'list_elem_radio_' + i + '_' + k"
                             :value="elem.id"
                             v-model="question.pickedAnswers"
                             @input="onInput(i)"
                             @change="setSelectedAnswer(question.pickedAnswers, elem.id, i, k)"
                      >
                      <label :for="'list_elem_radio_' + i + '_' + k">
                        <input type="text"
                               class="input__text"
                               v-model="elem.text"
                               placeholder="Введите ответ"
                               @blur="updateTitleCheckbox(i, k)"
                        />
                      </label>
                    </div>

                    <transition name="fadeFast">
                      <div class="elem_basket"
                           v-if="question.answers.length > 2"
                           @click="deleteTaListElem('ratio', i, k)"
                      >
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.75 1.83398H8.25C7.23892 1.83398 6.41667 2.65623 6.41667 3.66732V5.50065H2.75V7.33398H4.58333V18.334C4.58333 19.3451 5.40558 20.1673 6.41667 20.1673H15.5833C16.5944 20.1673 17.4167 19.3451 17.4167 18.334V7.33398H19.25V5.50065H15.5833V3.66732C15.5833 2.65623 14.7611 1.83398 13.75 1.83398ZM8.25 3.66732H13.75V5.50065H8.25V3.66732ZM15.5833 18.334H6.41667V7.33398H15.5833V18.334Z" fill="#C5C5C9"/>
                        </svg>
                      </div>
                    </transition>
                  </div>
                  <div class="list_button"
                       @click="addItemToList('test', i)"
                  >
                    <div class="list_svg">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 4.58398V17.4173" stroke="#C0CADC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.58301 11H17.4163" stroke="#C0CADC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="list_title">
                      Добавить вариант ответа
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--multi checkbox-->
            <div class="task_block"
                 v-if="question.type === 1"
            >
              <div class="task_elem">
                <div class="elem_title">Варианты ответа*</div>

                <div class="task_list">
                  <div class="list_elem"
                       :class="(question.pickedAnswers.indexOf(elem.id) !== -1)?('list_elem__active'):('')"
                       v-for="(elem, k) in question.answers"
                       :key="'list_elem_' + i + '_' + k"
                  >
                    <div class="elem_block">
                      <input type="checkbox"
                             class="custom-checkbox"
                             :id="'list_elem_checkbox_' + i + '_' + k"
                             :name="'list_elem_checkbox_' + i + '_' + k"
                             :value="elem.id"
                             v-model="question.pickedAnswers"
                             @input="onInput(i)"
                             @change="setSelectedAnswer(question.pickedAnswers, elem.id, i, k)"
                      >
                      <label :for="'list_elem_checkbox_' + i + '_' + k">
                        <input type="text"
                               class="input__text"
                               v-model="elem.text"
                               placeholder="Введите ответ"
                               @blur="updateTitleCheckbox(i, k)"
                        />
                      </label>
                    </div>

                    <transition name="fadeFast">
                      <div class="elem_basket"
                           v-if="question.answers.length > 2"
                           @click="deleteTaListElem('checkbox', i, k)"
                      >
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.75 1.83398H8.25C7.23892 1.83398 6.41667 2.65623 6.41667 3.66732V5.50065H2.75V7.33398H4.58333V18.334C4.58333 19.3451 5.40558 20.1673 6.41667 20.1673H15.5833C16.5944 20.1673 17.4167 19.3451 17.4167 18.334V7.33398H19.25V5.50065H15.5833V3.66732C15.5833 2.65623 14.7611 1.83398 13.75 1.83398ZM8.25 3.66732H13.75V5.50065H8.25V3.66732ZM15.5833 18.334H6.41667V7.33398H15.5833V18.334Z" fill="#C5C5C9"/>
                        </svg>
                      </div>
                    </transition>
                  </div>
                  <div class="list_button"
                       @click="addItemToList('test', i)"
                  >
                    <div class="list_svg">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 4.58398V17.4173" stroke="#C0CADC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.58301 11H17.4163" stroke="#C0CADC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="list_title">
                      Добавить вариант ответа
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Правильный порядок -->
            <div class="task_block"
                 v-if="question.type === 4"
            >
              <div class="task_elem">
                <div class="elem_title">Правильный порядок*</div>

                <div class="task_list">
                  <draggable :list="question.answers"
                             handle=".handle"
                             @change="dragAnswer"
                             @start="dragAnswerStart(i)"
                             @end="dragAnswerStartEnd(i)"
                  >
                    <transition-group>
                      <div class="list_block"
                           v-for="(elem, k) in question.answers"
                           :key="'list_elem_' + i + '_' + elem.id"
                      >
                        <div class="list_elem">
                          <div class="elem_block">
                            <div class="elem_num">
                              {{k + 1}}
                            </div>
                            <input type="text"
                                   class="input__text"
                                   v-model="elem.text"
                                   placeholder="Введите ответ"
                                   @blur="updateTitleDragAnswer(i, k, elem)"
                            />
                          </div>

                          <transition name="fadeFast">
                            <div class="elem_basket"
                                 v-if="question.answers.length > 2"
                                 @click="deleteTaListElem('order', i, k)"
                            >
                              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.75 1.83398H8.25C7.23892 1.83398 6.41667 2.65623 6.41667 3.66732V5.50065H2.75V7.33398H4.58333V18.334C4.58333 19.3451 5.40558 20.1673 6.41667 20.1673H15.5833C16.5944 20.1673 17.4167 19.3451 17.4167 18.334V7.33398H19.25V5.50065H15.5833V3.66732C15.5833 2.65623 14.7611 1.83398 13.75 1.83398ZM8.25 3.66732H13.75V5.50065H8.25V3.66732ZM15.5833 18.334H6.41667V7.33398H15.5833V18.334Z" fill="#C5C5C9"/>
                              </svg>
                            </div>
                          </transition>
                        </div>

                        <div class="move_button handle">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6H20V8H4V6ZM4 11H20V13H4V11ZM4 16H20V18H4V16Z" fill="#AEBCD6"/>
                          </svg>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>

                  <div class="list_button"
                       @click="addItemToList('order', i)"
                  >
                    <div class="list_svg">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 4.58398V17.4173" stroke="#C0CADC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.58301 11H17.4163" stroke="#C0CADC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div class="list_title">
                      Добавить вариант ответа
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Параметры -->
            <div class="task_footer">
              <div class="task_params"
                  v-if="question.type === 2"
              >
                <div class="task_param"
                     v-for="(param, k) in taParams"
                     :key="'task_param_' + i + '_' + k"
                >
                  <input type="checkbox"
                         class="task_checkbox"
                         :id="'param_checkbox_' + i + '_' + k"
                         :name="'param_checkbox_' + i + '_' + k"
                         :value="param.id"
                         v-model="question.pickedParams"
                         @change="setParamsQuestion(param.id, question.pickedParams, i)"
                  >
                  <label :for="'param_checkbox_' + i + '_' + k">
                    {{param.title}}
                  </label>
                </div>
              </div>

              <div class="task_params"
                   v-else
              >
                <div class="task_param"
                     v-for="(param, k) in getTaParamsForCheckbox"
                     :key="'task_param_' + i + '_' + k"
                >
                  <input type="checkbox"
                         class="task_checkbox"
                         :id="'param_checkbox_' + i + '_' + k"
                         :name="'param_checkbox_' + i + '_' + k"
                         :value="param.id"
                         v-model="question.pickedParams"
                         @change="setParamsQuestion(param.id, question.pickedParams, i)"
                  >
                  <label :for="'param_checkbox_' + i + '_' + k">
                    {{param.title}}
                  </label>
                </div>
              </div>

              <div class="score">
                <div class="score_text">Макс. балл:</div>
                <input type="number"
                       class="input_score"
                       v-model="question.maxScore"
                       placeholder="1"
                       @blur="applyChanges(question.maxScore, {id: question.id, i: i, field: 'max_bal'}, false)"
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Кнопки добавления вопросов -->
        <div class="task_buttons"
             :class="(content.length > 0)?('task_buttons__margin'):('')"
        >
          <div class="task_button"
               @click="addTaQuestion(0)"
          >
            <div class="button_image">
              <svg width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="108" height="72" rx="4" fill="white"/>
                <rect x="0.5" y="0.5" width="107" height="71" rx="3.5" stroke="#8C71FE" stroke-opacity="0.2"/>
                <path d="M0 4C0 1.79086 1.79086 0 4 0H104C106.209 0 108 1.79086 108 4V11H0V4Z" fill="#B1A1F2"/>
                <circle cx="18" cy="41.5" r="6.25" stroke="#B1A1F2" stroke-width="1.5"/>
                <circle cx="18" cy="41.5" r="3" fill="#B1A1F2"/>
                <rect x="29" y="40.5" width="68" height="2" rx="1" fill="#B1A1F2"/>
                <rect x="29" y="36.5" width="37" height="2" rx="1" fill="#B1A1F2"/>
                <rect x="29" y="44.5" width="58" height="2" rx="1" fill="#B1A1F2"/>
                <circle cx="18" cy="24" r="6.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <rect x="29" y="21" width="50" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="29" y="25" width="59" height="2" rx="1" fill="#D0CDE1"/>
                <circle cx="18" cy="59" r="6.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <rect x="29" y="56" width="52" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="29" y="60" width="26" height="2" rx="1" fill="#D0CDE1"/>
              </svg>
            </div>
            <div class="button_text">
              Единичный выбор
            </div>
          </div>

          <div class="task_button"
               @click="addTaQuestion(1)"
          >
            <div class="button_image">
              <svg width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="108" height="72" rx="4" fill="white"/>
                <rect x="0.5" y="0.5" width="107" height="71" rx="3.5" stroke="#8C71FE" stroke-opacity="0.2"/>
                <path d="M0 4C0 1.79086 1.79086 0 4 0H104C106.209 0 108 1.79086 108 4V11H0V4Z" fill="#B1A1F2"/>
                <rect x="11.75" y="35.25" width="12.5" height="12.5" rx="2.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <rect x="29" y="40.5" width="68" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="29" y="36.5" width="37" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="29" y="44.5" width="58" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="11" y="17" width="14" height="14" rx="3" fill="#B1A1F2"/>
                <path d="M16.9004 25.0624L15.3467 23.5088L15.2539 23.4159L15.1611 23.5088L14.4541 24.2158L14.3613 24.3086L14.4541 24.4014L16.8076 26.7549L16.9004 26.8477L16.9932 26.7549L21.8467 21.9014L21.9395 21.8086L21.8467 21.7158L21.1397 21.0088L21.0469 20.9159L20.9541 21.0088L16.9004 25.0624Z" fill="white" stroke="white" stroke-width="0.2625"/>
                <rect x="29" y="21" width="50" height="2" rx="1" fill="#B1A1F2"/>
                <rect x="29" y="25" width="59" height="2" rx="1" fill="#B1A1F2"/>
                <rect x="11" y="52" width="14" height="14" rx="3" fill="#B1A1F2"/>
                <path d="M16.9004 60.0624L15.3467 58.5088L15.2539 58.4159L15.1611 58.5088L14.4541 59.2158L14.3613 59.3086L14.4541 59.4014L16.8076 61.7549L16.9004 61.8477L16.9932 61.7549L21.8467 56.9014L21.9395 56.8086L21.8467 56.7158L21.1397 56.0088L21.0469 55.9159L20.9541 56.0088L16.9004 60.0624Z" fill="white" stroke="white" stroke-width="0.2625"/>
                <rect x="29" y="56" width="52" height="2" rx="1" fill="#B1A1F2"/>
                <rect x="29" y="60" width="26" height="2" rx="1" fill="#B1A1F2"/>
              </svg>
            </div>
            <div class="button_text">
              Множественный выбор
            </div>
          </div>

          <div class="task_button"
               @click="addTaQuestion(2)"
          >
            <div class="button_image">
              <svg width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="108" height="72" rx="4" fill="white"/>
                <rect x="0.5" y="0.5" width="107" height="71" rx="3.5" stroke="#8C71FE" stroke-opacity="0.2"/>
                <path d="M0 4C0 1.79086 1.79086 0 4 0H104C106.209 0 108 1.79086 108 4V11H0V4Z" fill="#B1A1F2"/>
                <rect x="11.5" y="34.5" width="85" height="23" rx="2.5" stroke="#B1A1F2"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.7458 40.0345C20.5654 40.0725 20.3855 40.1939 20.264 40.3596C20.1969 40.4512 17.2305 50.2131 17.0329 50.9925C16.958 51.288 17.0095 51.5091 17.2027 51.7216C17.5588 52.1131 18.1825 52.0383 18.4236 51.5752C18.4639 51.4977 18.6226 51.0122 18.7763 50.4961C18.9301 49.98 19.067 49.5211 19.0805 49.4763C19.1033 49.4005 19.231 49.3948 20.8973 49.3948H22.6896L23.0052 50.4546C23.1789 51.0375 23.3588 51.5656 23.4051 51.6281C23.6701 51.9858 24.1477 52.0755 24.4859 51.8309C24.6726 51.6959 24.8304 51.3616 24.8001 51.1651C24.7574 50.8877 21.6305 40.528 21.5463 40.3849C21.3858 40.112 21.0587 39.9688 20.7458 40.0345ZM26.6488 40.0356C26.4462 40.0959 26.2362 40.2847 26.1507 40.4833C26.0971 40.6077 26.0861 41.5456 26.0861 45.9938C26.0861 51.8546 26.071 51.5391 26.3632 51.7833C26.6218 51.9995 26.7806 52.0153 28.4543 51.9919C30.218 51.9673 30.4146 51.9366 31.1173 51.5761C31.6525 51.3015 32.2714 50.6884 32.5434 50.1635C32.8845 49.5051 32.9564 49.1957 32.9551 48.3931C32.9538 47.5709 32.8945 47.2962 32.5827 46.6652C32.3562 46.2069 31.9407 45.714 31.5259 45.4115L31.2957 45.2436L31.4532 45.0386C32.1445 44.1389 32.2417 42.658 31.679 41.5987C31.4292 41.1284 30.9099 40.6206 30.4239 40.3711C29.7873 40.0445 29.657 40.0234 28.1495 40.004C27.3017 39.9931 26.7529 40.0047 26.6488 40.0356ZM37.2002 40.0304C35.9573 40.1906 34.9579 41.0148 34.5447 42.2202C34.4619 42.4618 34.4568 42.6781 34.4568 45.9938C34.4568 49.3095 34.4619 49.5259 34.5447 49.7675C34.8849 50.7601 35.6562 51.5304 36.6058 51.8263C37.2746 52.0347 38.1584 52.0314 38.8502 51.818C39.5836 51.5917 40.3248 50.962 40.6652 50.2759C40.9068 49.7891 40.9968 49.3735 40.9979 48.7408C40.9989 48.1222 40.9035 47.8921 40.5784 47.7292C40.3186 47.5991 40.1474 47.597 39.8898 47.7209C39.5577 47.8806 39.4837 48.0533 39.4523 48.7401C39.4304 49.2191 39.4062 49.3644 39.3183 49.5435C39.1633 49.8591 38.8784 50.1277 38.5207 50.2954C38.2304 50.4316 38.1737 50.4417 37.716 50.439C37.3205 50.4367 37.1701 50.4153 36.9518 50.3305C36.5771 50.1851 36.2162 49.8298 36.0824 49.4744C35.982 49.2077 35.9809 49.1721 35.9809 45.9938C35.9809 42.8156 35.982 42.78 36.0824 42.5133C36.2162 42.1579 36.5771 41.8026 36.9518 41.6571C37.1701 41.5724 37.3205 41.551 37.716 41.5487C38.1736 41.546 38.2305 41.5561 38.5203 41.692C38.8886 41.8647 39.1575 42.1164 39.3127 42.4334C39.4031 42.6184 39.4303 42.7665 39.453 43.1986C39.4839 43.7864 39.5101 43.863 39.7532 44.0751C40.125 44.3994 40.6832 44.2824 40.9016 43.8343C41.0212 43.5888 41.0338 42.9303 40.9284 42.4299C40.7441 41.5551 40.104 40.758 39.2318 40.3175C38.75 40.074 37.8492 39.9468 37.2002 40.0304ZM29.6105 41.6686C29.9233 41.8138 30.2114 42.0932 30.3624 42.3976C30.4566 42.5876 30.4708 42.6862 30.4708 43.152C30.4707 43.6421 30.4601 43.7077 30.346 43.9225C30.1786 44.2377 29.8645 44.5155 29.539 44.6365C29.3033 44.7241 29.1739 44.736 28.4525 44.736H27.6336V43.1242V41.5125L28.4895 41.529C29.2986 41.5445 29.3597 41.5521 29.6105 41.6686ZM21.6772 46.0288L22.2267 47.8574H20.8922C19.7469 47.8574 19.5614 47.8478 19.5837 47.7899C19.598 47.7529 19.8756 46.8357 20.2005 45.7517C20.5255 44.6678 20.8154 43.7075 20.8448 43.6178L20.8982 43.4548L21.013 43.8275C21.076 44.0325 21.3749 45.023 21.6772 46.0288ZM30.1469 46.3972C30.6824 46.6093 31.0987 47.0161 31.2956 47.5195C31.4529 47.9217 31.4752 48.6316 31.344 49.0608C31.1659 49.6429 30.7347 50.1143 30.1821 50.3307C29.9286 50.4299 29.8229 50.4394 28.7708 50.4564L27.6336 50.4748V48.3693V46.2638L28.7708 46.2832C29.7756 46.3004 29.9359 46.3137 30.1469 46.3972Z" fill="#B1A1F2"/>
                <rect x="11" y="22" width="86" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="11" y="17" width="47" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="11" y="27" width="73" height="2.5" rx="1.25" fill="#D0CDE1"/>
              </svg>
            </div>
            <div class="button_text">
              С кратким ответом
            </div>
          </div>
          <div class="task_button"
               @click="addTaQuestion(3)"
          >
            <div class="button_image">
              <svg width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="108" height="72" rx="4" fill="white"/>
                <rect x="0.5" y="0.5" width="107" height="71" rx="3.5" stroke="#8C71FE" stroke-opacity="0.2"/>
                <rect x="40.75" y="30.75" width="28.5" height="11.5" rx="2.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <rect x="11" y="35" width="26" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="73" y="35" width="26" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="26.75" y="47.25" width="28.5" height="11.5" rx="2.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <rect x="11" y="51.5" width="12" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="59" y="51.5" width="40" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="11" y="24" width="68" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="82" y="24" width="15" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <path d="M0 4C0 1.79086 1.79086 0 4 0H104C106.209 0 108 1.79086 108 4V11H0V4Z" fill="#B1A1F2"/>
              </svg>
            </div>
            <div class="button_text">
              Заполнить пропуски
            </div>
          </div>
          <div class="task_button"
               @click="addTaQuestion(4)"
          >
            <div class="button_image">
              <svg width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="108" height="72" rx="4" fill="white"/>
                <rect x="0.5" y="0.5" width="107" height="71" rx="3.5" stroke="#8C71FE" stroke-opacity="0.2"/>
                <path d="M17 28.5H11V27.2786H13.3899V21.0171L11.4528 22.0714V20.6957L13.5283 19.5H14.7484V27.2786H17V28.5Z" fill="#B1A1F2"/>
                <path d="M17 45.5H11V44.4902L13.7105 41.8899C14.2854 41.3429 14.7084 40.8717 14.9795 40.4762C15.2259 40.0975 15.3491 39.6935 15.3491 39.2644C15.3491 38.8184 15.1889 38.4607 14.8686 38.1914C14.5565 37.9137 14.1458 37.7749 13.6366 37.7749C12.7741 37.7749 11.9692 38.141 11.2218 38.8731V37.4215C11.9281 36.8072 12.7782 36.5 13.7721 36.5C14.5852 36.5 15.2752 36.7398 15.8419 37.2195C16.4168 37.6992 16.7043 38.3261 16.7043 39.1003C16.7043 39.6978 16.5606 40.2405 16.2731 40.7286C15.9692 41.2251 15.4846 41.7973 14.8193 42.4453L12.9589 44.263H17V45.5Z" fill="#B1A1F2"/>
                <path d="M13.5963 62.5C12.5694 62.5 11.7039 62.277 11 61.831V60.4804C11.7122 61.0021 12.5528 61.263 13.5217 61.263C14.0932 61.263 14.5859 61.1031 15 60.7833C15.4141 60.4551 15.6211 60.0175 15.6211 59.4705C15.6211 58.9572 15.4389 58.5449 15.0745 58.2335C14.7101 57.9137 14.2215 57.7539 13.6087 57.7539C13.2112 57.7539 12.8427 57.8212 12.5031 57.9558V57.0091L14.8385 54.7118H11.323V53.5H16.6522V54.5477L14.4286 56.7188C15.1242 56.7945 15.7288 57.0806 16.2422 57.5771C16.7474 58.0652 17 58.6964 17 59.4705C17 60.3794 16.6729 61.1115 16.0186 61.6669C15.3727 62.2223 14.5652 62.5 13.5963 62.5Z" fill="#B1A1F2"/>
                <path d="M0 4C0 1.79086 1.79086 0 4 0H104C106.209 0 108 1.79086 108 4V11H0V4Z" fill="#B1A1F2"/>
                <rect x="22.5" y="18.5" width="74" height="11" rx="2.5" stroke="#D0CDE1"/>
                <rect x="27" y="23" width="59" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="22.5" y="35.5" width="74" height="11" rx="2.5" stroke="#D0CDE1"/>
                <rect x="27" y="40" width="59" height="2" rx="1" fill="#D0CDE1"/>
                <rect x="22.5" y="52.5" width="74" height="11" rx="2.5" stroke="#D0CDE1"/>
                <rect x="27" y="57" width="59" height="2" rx="1" fill="#D0CDE1"/>
              </svg>
            </div>
            <div class="button_text">
              Последовательность
            </div>
          </div>
          <div class="task_button"
               @click="addTaQuestion(5)"
          >
            <div class="button_image">
              <svg width="108" height="72" viewBox="0 0 108 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="108" height="72" rx="4" fill="white"/>
                <rect x="0.5" y="0.5" width="107" height="71" rx="3.5" stroke="#8C71FE" stroke-opacity="0.2"/>
                <rect x="30.75" y="30.75" width="38.5" height="11.5" rx="2.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <rect x="11" y="35" width="16" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="73" y="35" width="26" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="11.75" y="47.25" width="38.5" height="11.5" rx="2.25" stroke="#D0CDE1" stroke-width="1.5"/>
                <path d="M45.9314 51.4291L45.8254 51.323L45.7193 51.4291L43.5 53.6484L41.2807 51.4291L41.1746 51.323L41.0685 51.4291L40.3026 52.195L40.1966 52.3011L40.3026 52.4071L43.3939 55.4984L43.5 55.6045L43.606 55.4984L46.6973 52.4071L46.8034 52.3011L46.6973 52.195L45.9314 51.4291Z" fill="#D0CDE1" stroke="#D0CDE1" stroke-width="0.3"/>
                <rect x="54" y="51.5" width="45" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="11" y="24" width="68" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <rect x="82" y="24" width="15" height="2.5" rx="1.25" fill="#D0CDE1"/>
                <path d="M0 4C0 1.79086 1.79086 0 4 0H104C106.209 0 108 1.79086 108 4V11H0V4Z" fill="#B1A1F2"/>
              </svg>
            </div>
            <div class="button_text">
              Выбор из списков
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="folder">
          <div class="folder_title">Наименование теста</div>
          <input type="text"
                 class="default_input"
                 v-model="titleTest"
                 placeholder="Введите наименование"
                 @blur="saveNewTitleTest()"
          >
        </div>

        <div class="folder">
          <div class="folder_title">Папка теста</div>

          <div class="elem_input elem_input_folder"
               @click="showModalChoiceFolder($event)"
          >
            <div class="input_block">
              <div class="input_text">
               {{activeFolder.title}}
              </div>
            </div>

            <div class="input_image"
                 :class="(showSidebarFolderModal)?('input_image__active'):('')"
            >
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9353 8.51953L11 12.4548L7.06478 8.51953L5.76862 9.8157L11 15.0471L16.2314 9.8157L14.9353 8.51953Z" fill="#C5C5C9"/>
              </svg>
            </div>

            <transition name="fadeFast">
              <div class="input_popup"
                   v-clickOutside="(e) => closeModalChoiceFolder(e)"
                   v-if="showSidebarFolderModal"
              >
                <div class="popup_element"
                     :class="(activeFolder.id === item.id)?('popup_element__active'):('')"
                     v-for="(item, i) in folders"
                     @click="setFolder(i)"
                >
                  {{item.title}}
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div class="score_container">
          <div class="score_header">
            <div class="score_title">
              Проходной балл
            </div>
            <div class="score_title">
              {{'Макс балл: ' + scoreInfo.maxScore}}
            </div>
          </div>
          <div class="score_border"></div>
          <div class="score_body">
            <div class="input_container">
              <input type="number"
                     class="input_score_percent"
                     v-model="scoreInfo.passingPercentScore"
                     placeholder="0"
                     @input="inputPassingPercentScore"
                     @blur="setPassingScore()"
              >
              <div class="score_input__background score_svg">
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.81063 12H2.46663L9.09063 0.799999H10.4186L3.81063 12ZM3.20263 0.591999C4.00263 0.591999 4.66396 0.853333 5.18663 1.376C5.70929 1.89867 5.97063 2.544 5.97063 3.312C5.97063 4.08 5.70929 4.72533 5.18663 5.248C4.66396 5.76 4.00263 6.016 3.20263 6.016C2.42396 6.016 1.76796 5.76 1.23463 5.248C0.722625 4.71467 0.466625 4.06933 0.466625 3.312C0.466625 2.55467 0.722625 1.90933 1.23463 1.376C1.75729 0.853333 2.41329 0.591999 3.20263 0.591999ZM3.20263 4.848C3.63996 4.848 3.99729 4.704 4.27463 4.416C4.56263 4.11733 4.70663 3.74933 4.70663 3.312C4.70663 2.864 4.56796 2.496 4.29063 2.208C4.01329 1.92 3.65063 1.776 3.20263 1.776C2.77596 1.776 2.42396 1.92533 2.14663 2.224C1.86929 2.512 1.73063 2.87467 1.73063 3.312C1.73063 3.74933 1.86929 4.11733 2.14663 4.416C2.42396 4.704 2.77596 4.848 3.20263 4.848ZM9.65063 6.784C10.4506 6.784 11.112 7.04533 11.6346 7.568C12.1573 8.09067 12.4186 8.73067 12.4186 9.488C12.4186 10.256 12.1573 10.9013 11.6346 11.424C11.112 11.9467 10.4506 12.208 9.65063 12.208C8.86129 12.208 8.20529 11.9467 7.68263 11.424C7.17063 10.9013 6.91463 10.256 6.91463 9.488C6.91463 8.73067 7.17063 8.09067 7.68263 7.568C8.20529 7.04533 8.86129 6.784 9.65063 6.784ZM9.65063 11.024C10.0986 11.024 10.4613 10.88 10.7386 10.592C11.016 10.304 11.1546 9.936 11.1546 9.488C11.1546 9.05067 11.0106 8.688 10.7226 8.4C10.4453 8.10133 10.088 7.952 9.65063 7.952C9.22396 7.952 8.87196 8.10133 8.59463 8.4C8.31729 8.688 8.17863 9.05067 8.17863 9.488C8.17863 9.92533 8.31729 10.2933 8.59463 10.592C8.87196 10.88 9.22396 11.024 9.65063 11.024Z" fill="#ABABB2"/>
                </svg>
              </div>
            </div>
            <div class="input_container">
              <input type="number"
                     class="input_score"
                     v-model="scoreInfo.passingScore"
                     placeholder="0"
                     @input="inputPassingScore"
                     @blur="setPassingScore()"
              >
              <div class="score_input__background score_text">
                Балл
              </div>
            </div>
          </div>
        </div>

        <transition name="fadeFast">
          <div class="sidebar"
               v-if="content.length > 0"
          >
            <div class="sidebar_list">
              <div class="list_elem"
                   v-for="(item, i) in content"
                   :key="'list_elem_' + i"
                   @click="goToQuestion(item.id)"
              >
                <div class="list_icon"
                     :class="(item.checkCompleted)?('list_icon__active'):('')"
                >
                  <div class="list_icon_svg"
                       v-if="item.checkCompleted"
                  >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.71645 8.26915L3.88834 6.44105L3.79554 6.34824L3.70273 6.44105L2.8779 7.26588L2.78509 7.35869L2.8779 7.45149L5.62365 10.1972L5.71645 10.2901L5.80926 10.1972L11.4717 4.53483L11.5645 4.44202L11.4717 4.34921L10.6468 3.52438L10.554 3.43157L10.4612 3.52438L5.71645 8.26915Z" fill="white" stroke="white" stroke-width="0.2625"/>
                    </svg>
                  </div>
                </div>
                <div class="list_title">
                  {{(item.questionHeader.length < 2)?((i + 1) + '. Вопрос'):((i + 1) + '. ' + item.questionHeader)}}
                </div>
              </div>
            </div>

            <div class="sidebar_border"></div>

            <div class="sidebar_buttons">
              <div class="sidebar_button sidebar_button__theme_purple"
                   @click="saveAndRedirectBack()"
              >
                Применить изменения
              </div>

              <div class="sidebar_button sidebar_button__theme_white"
                   @click="recheckThePasses()"
              >
                Перепроверить все прохождения
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import SlideUpDown from 'vue-slide-up-down';
  import AddFiles from '../DefaultComponents/AddFiles.vue';
  import Breadcrumbs from '../DefaultComponents/Breadcrumbs.vue';
  import addTest from './Pop-up/addTest.vue'
  import moduleLesson from './Pop-up/removeLesson.vue'
  import HeaderComponent from './HeaderFooterBlock/header.vue'
  import FooterComponent from './HeaderFooterBlock/footer.vue'
  import Editor from '../DefaultComponents/Editor/Editor.vue';
  import {databus} from '../databus.js';
  import {send} from "../fetchData";
  import draggable from 'vuedraggable';
  import VueScrollTo from 'vue-scrollto';
  Vue.use(VueScrollTo);

  let textVersion = require("textversionjs");

  export default {
    name: "AddTest",
    props: {
      parentPage: {  // name родительской страницы
        type: String,
        default() {
          return ''
        }
      },

      listFolders: {  // массив папок (используется при создании нового теста)
        type: Array,
        default() {
          return []
        }
      },
    },
    data() {
      return {
        scoreInfo: { // данные для блока "Проходной балл"
          maxScore: 0,  // максимальный балл
          passingScore: undefined, // проходной балл
          passingPercentScore: undefined  // проходной балл в процентах
        },

        listOfType: [
          {
            id: 0,
            title: 'Единичный выбор'
          },
          {
            id: 1,
            title: 'Множественный выбор'
          },
          {
            id: 2,
            title: 'С кратким ответом'
          },
          {
            id: 3,
            title: 'Заполнить пропуски'
          },
          {
            id: 4,
            title: 'Последовательность'
          },
          {
            id: 5,
            title: 'Выбор из списков'
          },
        ],
        showSidebarFolderModal: false, // отображение модального окна сортировки в sidebar
        activeFolder: {
          id: 0,
          title: 'Не сортировано'
        },

        titleTest: '', // наименование тестирования
        folders: [
          {
            id: 0,
            title: 'Не сортировано'
          },
        /*  {
            id: 1,
            title: 'Папка 1'
          },
          {
            id: 2,
            title: 'Папка 2'
          },
          {
            id: 3,
            title: 'Наименование папки очень длинное'
          },
          {
            id: 4,
            title: 'Папка 4'
          } */
        ],

        taDownloadMaterials: false,  // модальное окно загрузки материалов
        taLoadMaterials: {
          i: undefined,
        },
        taLoadFiles: {
          i: undefined
        },

        assessmentTechnique: [  // для типа 2 и 3 / техника оценивания
          {
            id: 1,
            title: 'Простое совпадение',
          },
          {
            id: 2,
            title: 'Случайный порядок',
          },
          {
            id: 3,
            title: 'Нужный порядок',
          },
        ],

        answerOptions: [  // для типа 5 / варианты ответа
          {
            id: 1,
            title: 'Одинаковые',
          },
          {
            id: 2,
            title: 'Различные',
          }
        ],

        taParams: [
          {
            id: 0,
            title: 'Пояснение к вопросу',
          },
          {
            id: 1,
            title: 'Включить видимость правильных ответов',
          },
          {
            id: 2,
            title: 'Многострочное поле ввода ответа',
          }
        ],

        activeIndexDraggableElem: undefined, // номер массива, в котором перемещают элементы
        indexDraggableItem: undefined, // нндекс переставляемого элемента
        content: [
         /* {
            id: 0,
            type: 0, // 0 - единичный выбор / 1 - множественный выбор / 2 - с кратким ответом
            checkCompleted: false, // заполненны ли все необходимые поля
            showModalQuestionType: false, // показать окно выбора типа вопроса
            downloadMaterials: [],
            questionHeader: '', // Заголовок для sidebar
            question: '', // вопрос
            explanationToQuestion: '', // пояснение к вопросу
            answers: [
              {
                id: 0,
                text: '',
              },
              {
                id: 1,
                text: '',
              }
            ],
            pickedAnswers: undefined,  // выбранные ответы
            inputAnswers: [], // для типа 2 / загруженные правильнае ответы
            inputRightAnswer: '', // введенные правильные ответы
            showInputRightAnswer: true, // показать input ввода текста
            showModalAssessmentTechnique: true, // для типа 2 / выбрать технику оценивания
            assessmentTechniqueActive: {  // выбранная техника оценивания
              id: 0,
              title: 'Простое совпадение',
            },
            pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
            maxScore: undefined,
          },
          {
            id: 1,
            type: 1, // 0 - единичный выбор / 1 - множественный выбор / 2 - с кратким ответом
            checkCompleted: false, // заполненны ли все необходимые поля
            showModalQuestionType: false, // показать окно выбора типа вопроса
            downloadMaterials: [],
            questionHeader: '', // Заголовок для sidebar
            question: '', // вопрос
            explanationToQuestion: '', // пояснение к вопросу
            answers: [
              {
                id: 0,
                text: '',
              },
              {
                id: 1,
                text: '',
              }
            ],
            pickedAnswers: [],  // выбранные ответы
            inputAnswers: [], // для типа 2 / загруженные правильнае ответы
            inputRightAnswer: '', // введенные правильные ответы
            showInputRightAnswer: true, // показать input ввода текста
            showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
            assessmentTechniqueActive: {  // выбранная техника оценивания
              id: 0,
              title: 'Простое совпадение',
            },
            pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
            maxScore: undefined,
          },
          {
            id: 2,
            type: 2, // 0 - единичный выбор / 1 - множественный выбор / 2 - с кратким ответом
            checkCompleted: false, // заполненны ли все необходимые поля
            showModalQuestionType: false, // показать окно выбора типа вопроса
            downloadMaterials: [],
            questionHeader: '', // Заголовок для sidebar
            question: '', // вопрос
            explanationToQuestion: '', // пояснение к вопросу
            answers: [
              {
                id: 0,
                text: '',
              },
              {
                id: 1,
                text: '',
              }
            ],
            pickedAnswers: undefined,  // выбранные ответы
            inputAnswers: [], // для типа 2 / загруженные правильнае ответы
            inputRightAnswer: '', // введенные правильные ответы
            showInputRightAnswer: true, // показать input ввода текста
            showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
            assessmentTechniqueActive: {  // выбранная техника оценивания
              id: 0,
              title: 'Простое совпадение',
            },
            pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
            maxScore: undefined,
          }  */
        ],
        breadcrumbs:[]
      }
    },

    created() {

      let titlePage;

      if (Number(this.$route.params.idTest) === -1) {
        // создать новый тест

        titlePage = 'Добавить тест';
        let data = {}

        data = {
            module: 'md_create_test',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            folder_id: this.$route.params.idFolder
          };

        console.log('data test')
        console.log(data)

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('md_create_test');
            console.log(response);

            let idPage;
            if (this.$route.params.idPage) {
              idPage = this.$route.params.idPage;
            } else {
              idPage = 'adminHomework';
            }

            this.$router.push({name: 'testsAddTest', params: {idCourse: this.$route.params.idCourse, idFolder: this.$route.params.idFolder, idTest: response.test_id, idPage: idPage, idLesson: this.$route.params.idLesson, idGroup:this.$route.params.idGroup}});


           this.folders = this.listFolders;

           for (let i = 0; i < this.folders.length; i++) {
             if (this.folders[i].id === Number(this.$route.params.idFolder)) {
               this.activeFolder = {
                 id: this.folders[i].id,
                 title: this.folders[i].title
               };

               break;
             }
           }

            this.breadcrumbs = [
              {
                id: 0,
                title: 'Тесты',
                link: {
                  name: 'adminTests',
                  params: {}
                }
              },
              {
                id: 1,
                title: titlePage,
                link: {
                  name: undefined,
                  params: {}
                }
              }
            ];
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      } else {
        titlePage = 'Редактировать тест';
        this.getData(titlePage);
      }
    },

    mounted() {

    },

    watch: {
      '$route'(to, from) {
        if ((Number(to.params.idTest) === -1) && (Number(from.params.idTest) >= 0)) {
          this.$router.push({name: 'adminTests', params: {idCourse: this.$route.params.idCourse}})
        }
      }
    },

    methods: {
      dragAnswer(elem) {
        console.log(elem)
        console.log('drag')

        let index = this.activeIndexDraggableElem;
        let data = {
          module: 'md_update_number_quest_sequence',
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[index].id,
          answer_id: elem.moved.element.id,
          number: elem.moved.newIndex + 1
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Номер изменен!');
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      dragAnswerStart(i) {
        this.activeIndexDraggableElem = i;
      },

      dragAnswerStartEnd(i) {
        this.activeIndexDraggableElem = undefined;
      },

      // обновить поле "Заполнить пропуски"
      updateFieldOmissions(updateContent, store) {

        let module = undefined;

        if (this.content[store.i].type === 3) {
          module = 'md_update_answer_input_quest_gap';
        } else if (this.content[store.i].type === 5) {
          module = 'md_update_answer_input_quest_gap_select';
        }

        console.log('store');
        console.log(store);
        console.log('updateContent');
        console.log(updateContent);
        console.log('this.content[store.i]');
        console.log(this.content[store.i]);

        let data = {
          module: module,
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[store.i].id,
          input_id: this.content[store.i].inputsContent[updateContent.i].id,
          answer_id: this.content[store.i].inputsContent[updateContent.i].answers[updateContent.j].id,
          text_answer: updateContent.newValue,
          text_quest: updateContent.content
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {

            if ((this.content[store.i].type === 5) && (this.content[store.i].assessmentTechniqueActive.id === 1)) { // одинаковые ответы
              this.content[store.i].inputsContent.forEach((item, i) => {
                this.content[store.i].inputsContent[i].answers[updateContent.j].text = updateContent.newValue;
              })
            } else {
              this.content[store.i].inputsContent[updateContent.i].answers[updateContent.j].text = updateContent.newValue;
            }
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // сохранить наименование тестирования
      saveNewTitleTest() {
        let data = {
          module: 'md_update_test',
          course_id: this.$route.params.idCourse,  //  this.$route.params.idCourse
          test_id: this.$route.params.idTest,
          field: 'name',
          value: this.titleTest,
        };

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Имя теста изменено!');

          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // добавление нового поля в массив input
      addNewField(updateContent, store) {

        let module = undefined;

        if (this.content[store.i].type === 3) {
          module = 'md_add_answer_input_quest_gap';
        } else if (this.content[store.i].type === 5) {
          module = 'md_add_answer_input_quest_gap_select';
        }

        let data = {
          module: module,
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[store.i].id,
          input_id: this.content[store.i].inputsContent[updateContent.i].id,
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('add answer quest');
            console.log(response);

            if ((this.content[store.i].type === 5) && (this.content[store.i].assessmentTechniqueActive.id === 1)) {

              response.inputs.forEach((item, i) => {

                for (let j = 0; j < this.content[store.i].inputsContent.length; j++) {
                  if (this.content[store.i].inputsContent[j].id === item.input_id) {
                    this.content[store.i].inputsContent[j].answers.push({
                      id: item.answer_id,
                      text: ''
                    });
                    
                    break;
                  }
                }

              });

            } else {
              this.content[store.i].inputsContent[updateContent.i].answers.push({
                id: response.answer_id,
                text: ''
              });
            }
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // удаление поля из массива input
      deleteField(updateContent, store) {

        let module = undefined;

        if (this.content[store.i].type === 3) {
          module = 'md_remove_answer_input_quest_gap';
        } else if (this.content[store.i].type === 5) {
          module = 'md_remove_answer_input_quest_gap_select';
        }

        let data = {
          module: module,
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[store.i].id,
          input_id: this.content[store.i].inputsContent[updateContent.i].id,
          answer_id: this.content[store.i].inputsContent[updateContent.i].answers[updateContent.j].id,
          text_answer: this.content[store.i].inputsContent[updateContent.i].answers[updateContent.j].text,
          text_quest: updateContent.content
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {

            if ((this.content[store.i].type === 5) && (this.content[store.i].assessmentTechniqueActive.id === 1)) { // одинаковые ответы
              this.content[store.i].inputsContent.forEach((item, i) => {
                this.content[store.i].inputsContent[i].answers.splice(updateContent.j, 1);
              })
            } else {
              this.content[store.i].inputsContent[updateContent.i].answers.splice(updateContent.j, 1);
            }
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // добавлено новое поле ввода (input)
      addInput(updateContent, store, content) {
        let module = undefined;

        if (updateContent.type === 3) {
          module = 'md_add_input_quest_gap';
        } else if (updateContent.type === 5) {
          module = 'md_add_input_quest_gap_select';
        }

        let data = {
          module: module,
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[store.i].id,
          text_quest: content.replaceAll('custom_input__active', '')
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('response');
            console.log(response);

            console.log('updateContent');
            console.log(updateContent);

            let answers = [];

            if (updateContent.type === 3) {
              answers.push({
                id: response.answer_id,
                text: ''
              })
            } else if (updateContent.type === 5) {
              if ((this.content[store.i].assessmentTechniqueActive.id === 1) && (this.content[store.i].inputsContent.length > 0)) { // Одинаковые и при этом есть хотя бы 1 инпут уже
                response.answers.forEach((item, k) => {
                  answers.push({
                    id: item.id,
                    text: item.answer
                  })
                })
              } else {  //  Различные
                response.answer_id.forEach((item, k) => {
                  answers.push({
                    id: item,
                    text: ''
                  })
                })
              }

            }

            this.content[store.i].inputsContent.push({
              id: response.input_id,  // updateContent.id
              pickedAnswer: updateContent.pickedAnswer, // выбранный ответ, используется если typeEditor === 2
              answers: answers
            });

            let dataInput = {};

            dataInput = {
              type: 3,
              idEditor: this.content[store.i].id + '_' + this.content[store.i].typePoint,
              oldIdInput: updateContent.id,
              newIdInput: response.input_id,
              answers: [
                {
                  oldId: updateContent.answers[0].id,
                  newId: response.answer_id
                }
              ],
            };


            databus.$emit('updateIdInputAfterCreated', dataInput);

          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // удаление поля ввода (input)
      removeInput(updateContent, store) {

        let module = undefined;
        if (store.type === 3) {
          module = 'md_remove_input_quest_gap';
        } else if (store.type === 5) {
          module = 'md_remove_input_quest_gap_select';
        }

        let data = {
          module: module,
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[store.i].id,
          input_id: updateContent.id,
          text_quest: updateContent.content
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Поле успешно удалено!');

            for (let i = 0; i < this.content[store.i].inputsContent.length; i++) {
              if (this.content[store.i].inputsContent[i].id === updateContent.id) {
                this.content[store.i].inputsContent.splice(i, 1);
                break;
              }
            }

           // databus.$emit('updateContentEditor', {});
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // обновление данных о выбранном правильном ответе
      updateSelectedAnswer(updateContent, store) {

        let data = {
          module: 'md_select_answer_input_quest_gap_select',
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[store.i].id,
          input_id: this.content[store.i].inputsContent[updateContent.i].id,
          answer_id: updateContent.newValue,
          text_quest: updateContent.content
        };

        console.log('md_select_answer_input_quest_gap_select');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Поле успешно изменено!');
            console.log(store);
            console.log(updateContent);
            console.log(this.content[store.i].inputsContent);

            this.content[store.i].inputsContent[updateContent.i].pickedAnswer = updateContent.newValue;
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // изменить title элемента draggable
      updateTitleDragAnswer(i, j, elem) {
        let data = {
          module: 'md_update_answer_quest_sequence',
          course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
          test_id: Number(this.$route.params.idTest),
          quest_id: this.content[i].id,
          answer_id: elem.id,
          answer: elem.text
        };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Поле успешно изменено!');
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // получить информацию о созданном тесте
      getData(titlePage) {
        // получить данные о тесте
        let breadcrumbs = [];
        if (this.$route.params.breadcrumbsList && (this.$route.params.breadcrumbsList.length > 0)) {
          this.$route.params.breadcrumbsList.forEach((item, i) => {
            breadcrumbs.push(item);
          })
        } else {
          breadcrumbs.push({
            id: 0,
            title: 'Тесты',
            link: {
              name: 'adminTests',
              params: {}
            }
          })
        }

        this.breadcrumbs = breadcrumbs;
        this.breadcrumbs.push({
          id: breadcrumbs.length,
          title: titlePage,
          link: {
            name: undefined,
            params: {}
          }
        });

        this.content = [];

        let data = {};

         data = {
            module: 'md_get_test',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: Number(this.$route.params.idTest)
         };

        console.log('data test')
        console.log(data)

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('get test');
            console.log(response);

            this.titleTest = response.test.name;

            response.folders.forEach((item, i) => {

              if ((item.id === response.test.folder_id)) {
                this.activeFolder = {
                  id: item.id,
                  title: ((item.name) && (item.name.length > 0))?(item.name):('Новая папка')
                }
              }

              this.folders.push({
                id: item.id,
                title: ((item.name) && (item.name.length > 0))?(item.name):('Новая папка')
              })
            });


            response.test.questions.forEach((item, i) => {
              let type = undefined;

              switch (item.type) {
                case 1:
                  type = 2; // С кратким ответом
                  break;

                case 2:
                  if (item.is_multi_response) {
                    type = 1; // Множественный выбор
                  } else {
                    type = 0; // Единичный выбор
                  }
                  break;

                case 3:
                  type = 4; // Последовательность
                  break;

                case 4:
                  type = 3; // Заполнить пропуски
                  break;

                case 5:
                  type = 5; // Выбор из списков
                  break;
              }

              let files = [];

              item.extends.forEach((file, i) => {
                files.push({
                  id: file.id,
                  data: file.file
                })
              });

              let pickedParams = [];

              if (item.is_comment) {
                pickedParams.push(0)
              }

              if (item.is_show_correct) {
                pickedParams.push(1)
              }

              if (item.is_multiline) {
                pickedParams.push(2)
              }

              let inputAnswers = [];
              let pickedAnswers = [];
              let answers = [];
              let inputsContent = [];
              let assessmentTechniqueActive = {};
              // настройка вариантов ответа (их добавление, при отсутствии)

              switch (item.type) {
                case 1: // текстовый
                  item.answers.forEach((answer, j) => {
                    inputAnswers.push({
                      id: answer.id,
                      text: answer.answer
                    })
                  });

                  // assessmentTechniqueActive
                  for (let k = 0; k < this.assessmentTechnique.length; k++) {
                    if (this.assessmentTechnique[k].id === item.check_type) {
                      assessmentTechniqueActive = this.assessmentTechnique[k];
                      break;
                    }
                  }
                  break;
                case 2: // тестовый
                  if (item.answers.length === 0) {  // если это тестовый тип и вопросов в тесет нет
                    // создаем 2 вопроса
                    this.addEmptyAnswer(this.$route.params.idCourse, this.$route.params.idTest, item.id, i)

                  } else {

                    item.answers.forEach((answer, i) => {
                      answers.push({
                        id: answer.id,
                        text: answer.answer
                      });
                    });

                    if (item.is_multi_response) { // несколько ответов
                      item.answers.forEach((answer, i) => {
                        if (Number(answer.correct) > 0) {
                          pickedAnswers.push(answer.id)
                        }
                      });
                    } else { //  одинарный ответ
                      pickedAnswers = undefined;

                      item.answers.forEach((answer, i) => {
                        if (Number(answer.correct) > 0) {
                          pickedAnswers = answer.id
                        }
                      });
                    }

                  }
                  break;

                case 3: // последовательность
                  item.answers.forEach((answer, j) => {
                    answers.push({
                      id: answer.id,
                      text: answer.answer,
                      number: answer.number
                    });
                  });

                  assessmentTechniqueActive = this.assessmentTechnique[0];
                  break;

                case 4: // заполнить поля
                  item.inputs.forEach((input, j) => {
                    let answers = [];

                    input.answers.forEach((answer, k) => {
                      answers.push({
                        id: answer.id,
                        text: answer.answer
                      });
                    });


                    inputsContent.push({
                      id: input.id,
                      pickedAnswer: undefined,
                      answers: answers,
                    });
                  });
                  break;

                case 5: // выбор из списка
                  let idAnswerOptions = (item.is_multiselect)?(2):(1);  // 1 - Одинаковые / 2 - Различные

                  for (let k = 0; k < this.answerOptions.length; k++) {
                    if (this.answerOptions[k].id === idAnswerOptions) {
                      assessmentTechniqueActive = this.answerOptions[k];
                      break;
                    }
                  }

                  item.inputs.forEach((input, j) => {
                    let idPickedAnswer = undefined;
                    let answers = [];

                    input.answers.forEach((answer, k) => {
                      answers.push({
                        id: answer.id,
                        text: answer.answer
                      });

                      if (answer.correct) {
                        idPickedAnswer = answer.id
                      }
                    });

                    inputsContent.push({
                      id: input.id,
                      pickedAnswer: idPickedAnswer,
                      answers: answers,
                    });
                  });
                  break;
              }

              this.scoreInfo.maxScore += Number(item.max_bal);

              let question = {
                id: item.id,
                type: type, // 0 - Единичный выбор / 1 -  Множественный выбор / 2 -  С кратким ответом / 3 - Заполнить пропуски / 4 -  Последовательность / 5 - Выбор из списков
                typePoint: item.type,
                keyEditor: 0,
                checkCompleted: false, // заполненны ли все необходимые поля
                showModalQuestionType: false, // показать окно выбора типа вопроса
                downloadMaterials: files,
                questionHeader: textVersion(item.text), // Заголовок для sidebar
                question: item.text, // вопрос
                explanationToQuestion: item.comment, // пояснение к вопросу
                inputsContent: inputsContent, // для типа 3 и 5
                answers: answers,
                pickedAnswers: pickedAnswers,  // выбранные ответы
                inputAnswers: inputAnswers, // для типа 2 / загруженные правильнае ответы
                inputRightAnswer: '', // введенные правильные ответы
                showInputRightAnswer: true, // показать input ввода текста
                showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
                acceptCloseModalAssessmentTechnique: false, // разрешить закрыть модальное окно
                assessmentTechniqueActive: assessmentTechniqueActive,  // выбранная техника оценивания
                pickedParams: pickedParams, // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
                maxScore: item.max_bal
              };

              this.content.push(question);
              this.onInput(i);
            });

            this.scoreInfo.passingScore = 0;
            if (response.test.score_passing > 0) {
              this.scoreInfo.passingScore = response.test.score_passing;
            }

            this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
            console.log(error);

            if (error.response.data.error === 'not_access') {
              this.$router.push({name: 'page_404'});
            }
          });
      },

      // добавить 2 пустых варианта ответа
      addEmptyAnswer(course_id, test_id, quest_id, i) {
        for (let k = 0; k < 2; k++) {
          let data = {
            module: 'md_add_answer_quest_test',
            course_id: course_id,   //  this.$route.params.idCourse
            test_id: test_id,
            quest_id: quest_id,
          };

          console.log('data')
          console.log(data)
          send
            .post('tests.php', data)
            .then((response) => {
              console.log('True')
              this.content[i].answers.push({
                id: response.answer_id,
                text: '',
              })
            })
            .catch((error) => {
              console.log('error!');
              console.log(error.response);
            });
        }
      },

      // проходной балл
      inputPassingScore() {
        if (this.scoreInfo.passingScore < 0) {
          this.scoreInfo.passingScore = 0
        } else if (this.scoreInfo.passingScore > this.scoreInfo.maxScore) {
          this.scoreInfo.passingScore = this.scoreInfo.maxScore
        }

        this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));

        console.log('this.scoreInfo')
        console.log(this.scoreInfo)
      },

      // проходной балл в процентах
      inputPassingPercentScore() {
        if (this.scoreInfo.passingPercentScore < 0) {
          this.scoreInfo.passingPercentScore = 0
        } else if (this.scoreInfo.passingPercentScore > 100) {
          this.scoreInfo.passingPercentScore = 100
        }

        this.scoreInfo.passingScore = Math.round((this.scoreInfo.passingPercentScore * this.scoreInfo.maxScore) / 100);
        
      },

      // сохранить изменения и выйти
      saveAndRedirectBack() {
        switch (this.$route.params.idPage) {
          case 'lesson': // робит
            console.log('lesson');
            setTimeout(() => {
              this.$router.push({name: 'addLesson', params: {idLesson: this.$route.params.idLesson, idGroup:this.$route.params.idGroup, idBoolLesson: 'false' }})
            }, 100);
            break;

          case 'adminHomework':  // робит
            console.log('adminHomework');
            setTimeout(() => {
              this.$router.push({name: 'homeworkAnnualCourse', params: {idLesson: this.$route.params.idLesson, idGroup:this.$route.params.idGroup}})
            }, 100);
            break;

          case 'lessonMain':
            console.log('lessonMain');
            setTimeout(() => {
              this.$router.push({name: 'addLessonMain', params: {idLesson: this.$route.params.idLesson, idGroup:this.$route.params.idGroup}})
            }, 100);
            break;

          default:
            console.log('default');
            setTimeout(() => {
              this.$router.push({name: 'adminTests', params: {idCourse: this.$route.params.idCourse}})
            }, 100);
        }
      },

      // удалить тест
      deleteTest() {
        let data = {}
        data = {
            module: 'md_remove_test',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
          };
        
        send
          .post('tests.php', data)
          .then((response) => {
            if(this.$route.name === 'AddTest'){
              //this.$router.push({name: 'adminTests', params: {idCourse: this.$route.params.idCourse}})
              this.$router.push({name: 'addLesson', params: {idLesson: this.$route.params.idLesson, idGroup:this.$route.params.idGroup, idBoolLesson: 'false' }})
            }else if(this.$route.name === 'testsAddTest'){
              this.$router.push({name: 'adminTests', params: {idCourse: this.$route.params.idCourse}})
            }else if(this.$route.name === 'AddTestMain'){
              this.$router.push({name: 'addLessonMain', params: {idLesson: this.$route.params.idLesson, idGroup:this.$route.params.idGroup}})
            }
            

          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // установить / снять правильный вариант ответа
      setSelectedAnswer(pickedAnswers, id, i, k) {
        let data = {}
        data = {
            module: 'md_select_answer_quest_test',
            course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
            test_id: Number(this.$route.params.idTest),
            quest_id: this.content[i].id,
            answer_id: id,
            selected: (this.content[i].type === 0)?(pickedAnswers === id):(pickedAnswers.includes(id))
          };
        
        console.log('Установить чекбокс');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log(response);
            console.log('Чекбокс установлен / снят');
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // выбор параметров
      setParamsQuestion(paramId, pickedParams, i) {
        let check = pickedParams.includes(paramId);
        let field = '';

        switch (paramId) {
          case 0:
            field = 'is_comment';
            break;

          case 1:
            field = 'is_show_correct';
            break;

          case 2:
            field = 'is_multiline';
            break;
        }
        let data = {}
         data = {
            module: 'md_update_quest',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            type: this.content[i].typePoint,
            field: field,
            value: check
          };
        send
          .post('tests.php', data)
          .then((response) => {
            console.log(response);
            console.log('Параметр поля успешно изменен');
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },


      // применить изменения
      applyChanges(newValue, store, updateValue) {  // param, value, i
        let i = store.i;
        if (updateValue) {
          switch (store.nameUpdatedItem) {
            case 'question':
              this.content[i].question = newValue;
              break;

            case 'explanationToQuestion':
              this.content[i].explanationToQuestion = newValue;
              break;
          }
        }

        let value = newValue;
        if (store.field === 'max_bal') {
          if (value < 1) {
            this.content[i].maxScore = 1;
            value = 1;
          }

          this.scoreInfo.maxScore = 0;
          this.content.forEach((item, i) => {
            this.scoreInfo.maxScore += Number(item.maxScore);
          });

          if (this.scoreInfo.passingScore > this.scoreInfo.maxScore) {
            this.scoreInfo.passingScore = this.scoreInfo.maxScore;
            this.setPassingScore();
          }

          this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));
        }

        console.log('this.scoreInfo')
        console.log(this.scoreInfo)

        let data = {}
        data = {
            module: 'md_update_quest',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            type: this.content[i].typePoint,
            field: store.field,
            value: value
          };

        send
          .post('tests.php', data)
          .then((response) => {
            console.log(response);

            if (store.type && ((store.type === 3) || (store.type === 5))) {
              for (let j = 0; j < this.content[i].inputsContent.length; j++) {
                let idElem = 'custom_input_' + this.content[i].id + '_' + this.content[i].typePoint + '_' + this.content[i].inputsContent[j].id;

                if (value.indexOf('id="' + idElem + '"') === -1) {

                  let updateContent = {
                    content: value.replaceAll('custom_input__active', ''),
                    id: this.content[i].inputsContent[j].id,
                  };

                  let storeData = {
                    i: i,
                    type: store.type,
                  };

                  this.removeInput(updateContent, storeData);
                }
              }
            }
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // добавить значение input в массив для типа 2
      addRightAnswer(i) {
        if (this.content[i].inputRightAnswer.length > 0) {
        let data = {}
        data = {
            module: 'md_add_answer_quest_text',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            answer: this.content[i].inputRightAnswer
          };

          send
            .post('tests.php', data)
            .then((response) => {
             
              this.content[i].showInputRightAnswer = false;
              this.content[i].inputAnswers.push({
                id: response.answer_id,
                text: this.content[i].inputRightAnswer
              });
              this.content[i].inputRightAnswer = '';
              this.onInput(i);

            })
            .catch((error) => {
              console.log('error!');
              console.log(error);
              console.log(error.response);

              this.content[i].inputRightAnswer = '';
            });

        } else if (this.content[i].inputAnswers.length > 0) {
          this.content[i].showInputRightAnswer = false;
        }
      },

      // добавить поле ввода в тип 2
      addInputField(i) {
        if (!this.content[i].showInputRightAnswer) {
          this.content[i].showInputRightAnswer = true;
          setTimeout(() => {
            document.getElementById('inputRightAnswer_' + i).focus();
          });
        }
      },

      // удалить ответ для типа 2
      answerDelete(i, j) {
        let data = {}
        data = {
            module: 'md_remove_answer_quest_text',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            answer_id: this.content[i].inputAnswers[j].id
          };

        console.log('data');
        console.log(data);

        send
          .post('tests.php', data)
          .then((response) => {

            this.content[i].inputAnswers.splice(j, 1);

            if (this.content[i].inputAnswers.length === 0) {
              this.content[i].showInputRightAnswer = true;
            }

          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // перевести html в текст
      parseHTMLToText(i) {

        this.content[i].questionHeader = textVersion(this.content[i].question);

        this.onInput(i);
      },

      // событие при введение текста / выбора ответов в обязательных полях
      async onInput(i) {

        setTimeout(() => {
          let content = this.content[i];
          let checkPickedAnswers = false;
          let checkQuestionHeader = false;

          if (content.questionHeader.length > 1) {
            checkQuestionHeader = true;

            switch (content.type) {
              case 0: // Единичный выбор
                if ((content.pickedAnswers !== undefined) && (content.pickedAnswers > -Infinity)) {
                  checkPickedAnswers = true;
                }
                break;

              case 1: // Множественный выбор
                if (content.pickedAnswers.length !== 0) {
                  checkPickedAnswers = true;
                }
                break;

              case 2: // С кратким ответом
                if (content.inputAnswers.length !== 0) {
                  checkPickedAnswers = true;
                }
                break;

              case 3: // Заполнить пропуски
                if (content.inputsContent.length !== 0) {
                  checkPickedAnswers = true;
                }
                break;

              case 4: // Последовательность
                if (content.answers.length !== 0) {
                  checkPickedAnswers = true;
                }
                break;

              case 5: // Выбор из списков
                if (content.inputsContent.length !== 0) {
                  checkPickedAnswers = true;
                }
                break;
            }
          }

          if (checkPickedAnswers && checkQuestionHeader) {
            this.content[i].checkCompleted = true;
          } else {
            this.content[i].checkCompleted = false;
          }

        }, 1)
      },

      // перейти к вопросу
      goToQuestion(id) {
        VueScrollTo.scrollTo('#question_' + id, 500, {offset: -100});
      },

      // показать модальное окно выбора папки
      showModalChoiceFolder($event) {
        let path = $event.path || ($event.composedPath && $event.composedPath());
        let checkClickByFiles = false;

        for (let i = 0; i < path.length; i++) {

          if ((path[i].nodeName === 'DIV') && (path[i].className.indexOf('input_popup') !== -1)) {
            checkClickByFiles = true;
            break;
          }
        }

        if (!checkClickByFiles) {
          this.showSidebarFolderModal = !this.showSidebarFolderModal;
        }
      },

      // закрыть модальное окно выбора папки
      closeModalChoiceFolder($event) {
        if (this.showSidebarFolderModal) {
          let path = $event.path || ($event.composedPath && $event.composedPath());
          let checkClickByFiles = false;

          for (let k = 0; k < path.length; k++) {

            if ((path[k].nodeName === 'DIV') && (path[k].className.indexOf('elem_input_folder') !== -1)) {
              checkClickByFiles = true;
              break;
            }
          }

          if (!checkClickByFiles) {
            this.showSidebarFolderModal = false;
          }
        }
      },

      // задать проходной балл для теста
      setPassingScore() {
        let data = {
          module: 'md_update_test',
          course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
          test_id: this.$route.params.idTest,
          field: 'score_passing',
          value: this.scoreInfo.passingScore,
        };

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('успешно')
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // выбрать папку
      setFolder(i) {
        this.showSidebarFolderModal = false;

        let data = {}
        data = {
            module: 'md_update_test',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            field: 'folder',
            value: this.folders[i].id,
          };
        
        send
          .post('tests.php', data)
          .then((response) => {
            this.activeFolder.id = this.folders[i].id;
            this.activeFolder.title = this.folders[i].title;

            if(this.$route.name === 'AddTest' || this.$route.name === 'testsAddTest'){
              this.$router.push({name: 'testsAddTest', params: {idCourse: this.$route.params.idCourse, idFolder: this.folders[i].id, idTest: this.$route.params.idTest}})

            }else if(this.$route.name === 'AddTestMain'){
              this.$router.push({name: 'testsAddTest', params: {idCourse: this.$route.params.idCourse, idFolder: this.folders[i].id, idTest: this.$route.params.idTest}})

            }
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // добавить вопрос
      addTaQuestion(type) {  // 0 - Единичный выбор / 1 -  Множественный выбор / 2 -  С кратким ответом / 3 - Заполнить пропуски / 4 -  Последовательность / 5 - Выбор из списков

       /*if (type > 2) {  // временное условие - удалить!

          if (type === 3) {   // Заполнить пропуски
            let data = {
              id: 0,
              type: 3,  // 0 - Единичный выбор / 1 -  Множественный выбор / 2 -  С кратким ответом / 3 - Заполнить пропуски / 4 -  Последовательность / 5 - Выбор из списков
              typePoint: 4, // изменить! на typeServerQuest
              inputsContent: [],
              checkCompleted: false, // заполненны ли все необходимые поля
              showModalQuestionType: false, // показать окно выбора типа вопроса
              downloadMaterials: [],
              questionHeader: '', // Заголовок для sidebar
              question: '', // вопрос
              explanationToQuestion: '', // пояснение к вопросу
              answers: [],
              pickedAnswers: (Number(type) === 0)?(undefined):([]),  // выбранные ответы
              inputAnswers: [], // для типа 2 / загруженные правильнае ответы
              inputRightAnswer: '', // введенные правильные ответы
              showInputRightAnswer: true, // показать input ввода текста
              showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
              assessmentTechniqueActive: {  // выбранная техника оценивания / Варианты ответов в пропусках
                id: 1,
                title: 'Простое совпадение',
              },
              pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
              maxScore: 1
            };

            this.content.push(data);

            this.scoreInfo.maxScore += 1;
            this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));
          } else if (type === 4) {  // Последовательность
            let data = {
              id: 0,
              type: 4,  // 0 - Единичный выбор / 1 -  Множественный выбор / 2 -  С кратким ответом / 3 - Заполнить пропуски / 4 -  Последовательность / 5 - Выбор из списков
              typePoint: 3, // изменить! на typeServerQuest
              checkCompleted: false, // заполненны ли все необходимые поля
              showModalQuestionType: false, // показать окно выбора типа вопроса
              downloadMaterials: [],
              questionHeader: '', // Заголовок для sidebar
              question: '', // вопрос
              explanationToQuestion: '', // пояснение к вопросу
              answers: [
                {
                  id: 0,
                  text: '',
                },
                {
                  id: 1,
                  text: '',
                }
              ],
              pickedAnswers: (Number(type) === 0)?(undefined):([]),  // выбранные ответы
              inputAnswers: [], // для типа 2 / загруженные правильнае ответы
              inputRightAnswer: '', // введенные правильные ответы
              showInputRightAnswer: true, // показать input ввода текста
              showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
              assessmentTechniqueActive: {  // выбранная техника оценивания / Варианты ответов в пропусках
                id: 1,
                title: 'Простое совпадение',
              },
              pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
              maxScore: 1
            };

            this.content.push(data);

            this.scoreInfo.maxScore += 1;
            this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));
          } else if (type === 5) {  // Выбор из списков
            let data = {
              id: 0,
              type: 5,  // 0 - Единичный выбор / 1 -  Множественный выбор / 2 -  С кратким ответом / 3 - Заполнить пропуски / 4 -  Последовательность / 5 - Выбор из списков
              typePoint: 5, // изменить! на typeServerQuest
              inputsContent: [   // для типа 3 и 5
                /!*  {
                       id: 0,
                       pickedAnswer: undefined, // выбранный ответ, используется если typeEditor === 2
                       answers: [
                         {
                           id: 0,
                           text: 'Юрий Долгорукий'
                         }
                       ]
                     }  *!/
              ],
              checkCompleted: false, // заполненны ли все необходимые поля
              showModalQuestionType: false, // показать окно выбора типа вопроса
              downloadMaterials: [],
              questionHeader: '', // Заголовок для sidebar
              question: '', // вопрос
              explanationToQuestion: '', // пояснение к вопросу
              answers: [],
              pickedAnswers: (Number(type) === 0)?(undefined):([]),  // выбранные ответы
              inputAnswers: [], // для типа 2 / загруженные правильнае ответы
              inputRightAnswer: '', // введенные правильные ответы
              showInputRightAnswer: true, // показать input ввода текста
              showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
              acceptCloseModalAssessmentTechnique: false, // разрешить закрыть модальное окно
              assessmentTechniqueActive: {  // выбранная техника оценивания / Варианты ответов в пропусках
                id: 1,
                title: 'Одинаковые',
              },
              pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
              maxScore: 1
            };

            this.content.push(data);

            this.scoreInfo.maxScore += 1;
            this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));
          }

            return 0
        }   */

        let typeServerQuest = undefined;

        switch (Number(type)) {
          case 0:
            typeServerQuest = 2;  // typeServerQuest / 1 - текстовый, 2 - тестовый, 3 - последовательность, 4 - заполнить пропуски, 5 - выбор из списка)
            break;

          case 1:
            typeServerQuest = 2;
            break;

          case 2:
            typeServerQuest = 1;
            break;

          case 3:
            typeServerQuest = 4;
            break;

          case 4:
            typeServerQuest = 3;
            break;

          case 5:
            typeServerQuest = 5;
            break;
        }

        let dataSend = {};
        dataSend = {
            module: 'md_add_quest',
            course_id: this.$route.params.idCourse,
            test_id: this.$route.params.idTest,
            type: typeServerQuest,
            is_multi_response: (Number(type) === 0)?(false):(true)
          };

        send
          .post('tests.php', dataSend)
          .then((response) => {
            console.log('вопрос создан');
            console.log(response);

            let index = this.content.length;
            let assessmentTechniqueActive = {  // выбранная техника оценивания / Варианты ответов в пропусках
              id: 1,
              title: 'Простое совпадение',
            };

            if ((typeServerQuest === 2) || (typeServerQuest === 3)) { // если это вопрос с вариантами выбора ответов или воследовательность

              let module = '';

              switch (typeServerQuest) {
                case 2:
                  module = 'md_add_answer_quest_test';

                  for (let k = 0; k < 2; k++) {

                    let data = {
                      module: module,
                      course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
                      test_id: this.$route.params.idTest,
                      quest_id: response.quest_id,
                    };

                    send
                      .post('tests.php', data)
                      .then((response) => {
                        this.content[index].answers.push({
                          id: response.answer_id,
                          text: '',
                        })
                      })
                      .catch((error) => {
                        console.log('error!');
                        console.log(error.response);
                      });
                  }
                  break;

                case 3:
                  module = 'md_add_answer_quest_sequence';
                  let number = 1;
                  for (let k = 0; k < 2; k++) {

                    let data = {
                      module: module,
                      course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
                      test_id: this.$route.params.idTest,
                      quest_id: response.quest_id,
                    };

                    send
                      .post('tests.php', data)
                      .then((response) => {
                        this.content[index].answers.push({
                          id: response.answer_id,
                          text: '',
                          number: number,
                        });

                        number++;
                      })
                      .catch((error) => {
                        console.log('error!');
                        console.log(error.response);
                      });
                  }
                  break;
              }
            } else if (typeServerQuest === 5) {
              let idAnswerOptions = 2;  // 1 - Одинаковые / 2 - Различные

              for (let k = 0; k < this.answerOptions.length; k++) {
                if (this.answerOptions[k].id === idAnswerOptions) {
                  assessmentTechniqueActive = this.answerOptions[k];
                  break;
                }
              }
            }

            let data = {
              id: response.quest_id,
              type: Number(type),  // 0 - Единичный выбор / 1 -  Множественный выбор / 2 -  С кратким ответом / 3 - Заполнить пропуски / 4 -  Последовательность / 5 - Выбор из списков
              keyEditor: 0,
              typePoint: typeServerQuest,
              checkCompleted: false, // заполненны ли все необходимые поля
              showModalQuestionType: false, // показать окно выбора типа вопроса
              downloadMaterials: [],
              questionHeader: '', // Заголовок для sidebar
              question: '', // вопрос
              explanationToQuestion: '', // пояснение к вопросу
              inputsContent: [], // для "заполнить пропуски" и "выбрать из списка"
              answers: [],
              pickedAnswers: (Number(type) === 0)?(undefined):([]),  // выбранные ответы
              inputAnswers: [], // для типа 2 / загруженные правильнае ответы
              inputRightAnswer: '', // введенные правильные ответы
              showInputRightAnswer: true, // показать input ввода текста
              showModalAssessmentTechnique: false, // для типа 2 / выбрать технику оценивания
              assessmentTechniqueActive: assessmentTechniqueActive,  // выбранная техника оценивания / Варианты ответов
              pickedParams: [], // выбранные параметры / 0 - Пояснение к вопросу / 1 - Разрешить вставку ответа
              maxScore: 1
            };

            this.content.push(data);

            this.scoreInfo.maxScore += 1;
            this.scoreInfo.passingPercentScore = Math.round(((this.scoreInfo.passingScore * 100) / this.scoreInfo.maxScore));

          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // удалить элемент списка
      deleteTaListElem(type, i, k) {
        if (this.content[i].answers.length > 2) {  // минимально в списке 2 элемента

          let module = undefined;
          switch (type) {
            case 'ratio':
              module = 'md_remove_answer_quest_test';
              break;

            case 'checkbox':
              module = 'md_remove_answer_quest_test';
              break;

            case 'order':
              module = 'md_remove_answer_quest_sequence';
              break;
          }

          let data = {
              module: module,
              course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
              test_id: this.$route.params.idTest,
              quest_id: this.content[i].id,
              answer_id: this.content[i].answers[k].id
            };
          send
            .post('tests.php', data)
            .then((response) => {

              if ((type === 'ratio') || (type === 'order')) {
                this.content[i].answers.splice(k, 1);
              } else if (type === 'checkbox') {
                let itemId = this.content[i].answers[k].id;
                let indexInAnswers = this.content[i].pickedAnswers.indexOf(itemId);

                if (indexInAnswers !== -1) {
                  this.content[i].pickedAnswers.splice(indexInAnswers, 1);
                }

                this.content[i].answers.splice(k, 1);
              }

            })
            .catch((error) => {
              console.log('error!');
              console.log(error.response);
            });

        }
      },

      addItemToList(type, i) {

        let module = undefined;
        switch (type) {
          case 'test':
            module = 'md_add_answer_quest_test';
            break;

          case 'order':
            module = 'md_add_answer_quest_sequence';
            break;
        }

        let data = {
          module: module,
          course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
          test_id: this.$route.params.idTest,
          quest_id: this.content[i].id,
        };
        send
          .post('tests.php', data)
          .then((response) => {

            this.content[i].answers.push({
              id: response.answer_id,
              text: '',
            })
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // отправить на бек новое наименование чекбакса ответа
      updateTitleCheckbox(i, j) {
        let data = {}

        data = {
            module: 'md_update_answer_quest_test',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            answer_id: this.content[i].answers[j].id,
            answer: this.content[i].answers[j].text
          };

        send
          .post('tests.php', data)
          .then((response) => {


          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
      },

      // сменить тип вопроса
      setTypeQuestion(i, type) {
        if (this.content[i].type !== Number(type)) {
          let typeBackNew = undefined;

          switch (Number(type)) {
            case 0: // Единичный выбор
              typeBackNew = 2; // тестовый
              break;

            case 1: // Множественный выбор
              typeBackNew = 2; // тестовый
              break;

            case 2: // С кратким ответом
              typeBackNew = 1; // текстовый
              break;

            case 3: // Заполнить пропуски
              typeBackNew = 4; // заполнить пропуски
              break;

            case 4: // Последовательность
              typeBackNew = 3; // последовательность
              break;

            case 5: // Выбор из списков
              typeBackNew = 5; // выбор из списка
              break;
          }

          let th = this;

          if (this.content[i].typePoint !== typeBackNew) {
            // сменить тип
            let data = {};

            data = {
                module: 'md_update_quest',
                course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
                test_id: this.$route.params.idTest,
                quest_id: this.content[i].id,
                type: this.content[i].typePoint,
                field: 'type',
                value: typeBackNew
              };

            console.log('data')
            console.log(data)

            send
              .post('tests.php', data)
              .then((response) => {
                console.log(response);
                this.content[i].id = response.quest.id;
                let assessmentTechniqueActive = {};

                switch (typeBackNew) {
                  case 1:
                    for (let k = 0; k < this.assessmentTechnique.length; k++) {
                      if (this.assessmentTechnique[k].id === response.quest.check_type) {
                        assessmentTechniqueActive = this.assessmentTechnique[k];
                        break;
                      }
                    }

                    this.content[i].assessmentTechniqueActive = assessmentTechniqueActive;

                    updateData(response);
                    break;

                  case 2:
                    setType(type, typeBackNew);

                    this.content[i].answers = [];
                    if(this.$route.name === 'AddTest' || this.$route.name === 'testsAddTest'){
                      this.addEmptyAnswer(this.$route.params.idCourse, this.$route.params.idTest, response.quest.id, i)
                    }else if(this.$route.name === 'AddTestMain'){
                      this.addEmptyAnswer(this.$route.params.idCourse, this.$route.params.idTest, response.quest.id, i)
                    }
                    break;

                  case 3:
                    updateData(response);

                    break;

                  case 4:
                    updateData(response);
                    this.content[i].answers = [];
                    break;

                  case 5:
                    updateData(response);
                    this.content[i].answers = [];
                    break;
                }

              })
              .catch((error) => {
                console.log('error!');
                console.log(error.response);
                console.log(error);
              });
          } else {
            setType(type, this.content[i].typePoint);
          }

          // установить / поменять тип чекбоксов
          function setType(type, typeBackNew) {
            let data = {
                module: 'md_update_quest',
                course_id: th.$route.params.idCourse,   //  this.$route.params.idCourse
                test_id: th.$route.params.idTest,
                quest_id: th.content[i].id,
                type: typeBackNew,
                field: 'is_multi_response',
                value: (Number(type) === 1)?(true):(false)
              };         

            console.log('data')
            console.log(data)

            send
              .post('tests.php', data)
              .then((response) => {
                console.log(response);

                updateData(false)
              })
              .catch((error) => {
                console.log('error!');
                console.log(error.response);
              });
          }

          // обновить данные в data
          function updateData(response) {
            if (Number(type) === 0) {
              th.content[i].pickedAnswers = undefined;
            } else {
              th.content[i].pickedAnswers = [];
            }

            th.content[i].inputsContent = [];
            th.content[i].inputAnswers = [];
            th.content[i].inputRightAnswer = '';

            let indexParams = th.content[i].pickedParams.indexOf(2);
            if (indexParams !== -1) {
              th.content[i].pickedParams.splice(indexParams, 1)
            }

            th.content[i].typePoint = typeBackNew;
            th.content[i].type = Number(type);
            th.content[i].showModalQuestionType = false;

            if (response) {
              th.content[i].question = response.quest.text;
              th.content[i].explanationToQuestion = response.quest.comment;

              if (typeBackNew === 3) {  // последовательность
                th.content[i].answers = [];

                if (response.quest.answers.length > 0) {
                  response.quest.answers.forEach((item, k) => {
                    th.content[i].answers.push({
                      id: item.id,
                      text: item.text,
                      number: item.number,
                    });
                  });
                } else {
                  let number = 1;
                  for (let k = 0; k < 2; k++) {

                    let data = {
                      module: 'md_add_answer_quest_sequence',
                      course_id: th.$route.params.idCourse,   //  this.$route.params.idCourse
                      test_id: th.$route.params.idTest,
                      quest_id: th.content[i].id,
                    };

                    send
                      .post('tests.php', data)
                      .then((response) => {
                        th.content[i].answers.push({
                          id: response.answer_id,
                          text: '',
                          number: number,
                        });

                        number++;
                      })
                      .catch((error) => {
                        console.log('error!');
                        console.log(error.response);
                      });
                  }
                }
              } else if (typeBackNew === 5) {  // выбор из списка
                let idAnswerOptions = (response.quest.is_multiselect)?(2):(1);  // 1 - Одинаковые / 2 - Различные
                let assessmentTechniqueActive = {};

                for (let k = 0; k < th.answerOptions.length; k++) {
                  if (th.answerOptions[k].id === idAnswerOptions) {
                    assessmentTechniqueActive = th.answerOptions[k];
                    break;
                  }
                }

                th.content[i].assessmentTechniqueActive = assessmentTechniqueActive;
              }

            }

            th.content[i].questionHeader = textVersion(th.content[i].question);
            th.content[i].keyEditor++;

            console.log('th.content[i]')
            console.log(th.content[i])
          }
        }
      },

      // покзать / скрыть модальное окно выбора типа ответа
      showModalChoiceQuestionType($event, i) {
        let path = $event.path || ($event.composedPath && $event.composedPath());
        let checkClickByFiles = false;

        for (let l = 0; l < path.length; l++) {

          if ((path[l].nodeName === 'DIV') && (path[l].className.indexOf('input_popup') !== -1)) {
            checkClickByFiles = true;
            break;
          }
        }

        if (!checkClickByFiles) {
          this.content[i].showModalQuestionType = !this.content[i].showModalQuestionType;
        }
      },

      // закрыть окно выбора типа ответа
      closeModalQuestionType($event, i) {
        if (this.content[i].showModalQuestionType) {

          let path = $event.path || ($event.composedPath && $event.composedPath());
          let checkClickByFiles = false;

          for (let k = 0; k < path.length; k++) {

            if ((path[k].nodeName === 'DIV') && (path[k].className.indexOf('elem_input_QuestionType_' + i) !== -1)) {
              checkClickByFiles = true;
              break;
            }
          }

          if (!checkClickByFiles) {
            this.content[i].showModalQuestionType = false;
          }
        }
      },

      // установить новый тип вариантов ответов в пропусках
      setAnswerOptions(i, k) {

        let data = {
          module: 'md_update_quest',
          course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
          test_id: this.$route.params.idTest,
          quest_id: this.content[i].id,
          type: this.content[i].typePoint,
          field: 'is_multiselect',
          value: (this.answerOptions[k].id === 1)?(false):(true),   // 1 (false) - Одинаковые / 2 (true) - Различные
        };

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Поле успешно изменено!');
            console.log(response);

            this.content[i].assessmentTechniqueActive = this.answerOptions[k];
            this.content[i].showModalAssessmentTechnique = false;
            this.content[i].acceptCloseModalAssessmentTechnique = false;

            if (this.answerOptions[k].id === 1) {
              this.content[i].inputsContent.forEach((el, j) => {
                let answers = [];
                let inputsIndex = undefined;

                for (let d = 0; d < response.inputs.length; d++) {
                  if (el.id === response.inputs[d].id) {
                    inputsIndex = d;
                    console.log('inputsIndex = ' + inputsIndex)
                    break;
                  }
                }

                for (let k = 0; k < response.inputs[inputsIndex].answers.length; k++) {
                  answers.push({
                    id: response.inputs[inputsIndex].answers[k].id,
                    text: response.inputs[inputsIndex].answers[k].text
                  });
                }

                console.log('answers');
                console.log(answers);

                this.content[i].inputsContent[j].pickedAnswer = undefined;
                this.content[i].inputsContent[j].answers = answers;

                console.log('this.content[i].inputsContent[j].answers')
                console.log(this.content[i].inputsContent[j].answers)
              });

              console.log('this.content[i].inputsContent')
              console.log(this.content[i].inputsContent)

              databus.$emit('clearInputValue', {
                idEditor: this.content[i].id + '_' + this.content[i].typePoint
              });
            }
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
            console.log(error);
          });
      },

      // установить новый тип техники оценивания
      setAssessmentTechnique(i, k) {
        let typeBack = (this.content[i].type === 2)?(1):(2);  // 1 - текстовый / 2 - тестовый
        let data = {}
        data = {
            module: 'md_update_quest',
            course_id: Number(this.$route.params.idCourse),   //  this.$route.params.idCourse
            test_id: Number(this.$route.params.idTest),
            quest_id: this.content[i].id,
            type: typeBack,
            field: 'check_type',
            value: this.assessmentTechnique[k].id
          };        

        send
          .post('tests.php', data)
          .then((response) => {
            this.content[i].assessmentTechniqueActive = this.assessmentTechnique[k];
            this.content[i].showModalAssessmentTechnique = false;
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      // закрыть модальное окно выбота техники оценивания
      closeModalAssessmentTechnique($event, i) {
        if (this.content[i].showModalAssessmentTechnique && this.content[i].acceptCloseModalAssessmentTechnique) {

          let path = $event.path || ($event.composedPath && $event.composedPath());
          let checkClickByFiles = false;

          for (let k = 0; k < path.length; k++) {

            if ((path[k].nodeName === 'DIV') && (path[k].className.indexOf('elem_input_assessment_technique_' + i) !== -1)) {
              checkClickByFiles = true;
              break;
            }
          }

          if (!checkClickByFiles) {
            this.content[i].acceptCloseModalAssessmentTechnique = false;
            this.content[i].showModalAssessmentTechnique = false;
          }
        }
      },

      // открыть / закрыть модальное окно техники оценивания
      showModalChoiceAssessmentTechnique($event, i) {

        let path = $event.path || ($event.composedPath && $event.composedPath());
        let checkClickByFiles = false;

        for (let p = 0; p < path.length; p++) {

          if ((path[p].nodeName === 'DIV') && (path[p].className.indexOf('input_popup') !== -1)) {
            checkClickByFiles = true;
            break;
          }
        }

        if (!checkClickByFiles) {
          this.content[i].showModalAssessmentTechnique = !this.content[i].showModalAssessmentTechnique;

          if (this.content[i].showModalAssessmentTechnique) {
            setTimeout(() => {
              this.content[i].acceptCloseModalAssessmentTechnique = true;
            }, 100)
          } else {
            this.content[i].acceptCloseModalAssessmentTechnique = false;
          }
        }
      },

      // удалить файл загруженного материала
      deleteLoadFiles(i, k) {

        let data = {
            module: 'md_remove_extend_quest',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            type: this.content[i].typePoint,
            extend_id: this.content[i].downloadMaterials[k].id
          };

        send
          .post('tests.php', data)
          .then((response) => {

            this.content[i].downloadMaterials.splice(k, 1);

          })
          .catch((error) => {
            console.log('error!');
            console.log(error);
            console.log(error.response);
          });
      },

      // добавить файл к вопросу ТА
      addFile(obj) {
        let data = {
            module: 'md_add_extend_quest',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[this.taLoadMaterials.i].id,
            type: this.content[this.taLoadMaterials.i].typePoint,
            file_id: obj.id,
            name: obj.data.name,
          };

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('response');
            console.log(response);
            obj.data.full_link = obj.link;

            this.content[this.taLoadMaterials.i].downloadMaterials.push({
              id: response.extend_id,
              data: obj.data
            });
          })
          .catch((error) => {
            console.log('error!');
            console.log(error);
            console.log(error.response);
          });
      },

      // открыть модальное окно загрузки материалов
      openLoadFilesModal($event, i) {
        let path = $event.path || ($event.composedPath && $event.composedPath());
        let checkClickByFiles = false;

        for (let p = 0; p < path.length; p++) {

          if ((path[p].nodeName === 'DIV') && (path[p].className.indexOf('input_file__check_class') !== -1)) {
            checkClickByFiles = true;
            break;
          }
        }

        if (!checkClickByFiles) {
          this.taDownloadMaterials = true;
          this.taLoadMaterials.i = i;
        }
      },

      closeDownloadMaterials(loadFiles) {
        /*
        if ((loadFiles.length > 0) && (this.taLoadMaterials.i !== undefined)) {
          loadFiles.forEach((item, j) => {
            this.content[this.taLoadMaterials.i].downloadMaterials.push(item);
          });
        }
              */
        this.taDownloadMaterials = false;
        this.taLoadMaterials.i = undefined;
      },

      questionDelete(i) {  // удалить вопрос из та

        let data = {
            module: 'md_remove_quest',
            course_id: this.$route.params.idCourse,   //  this.$route.params.idCourse
            test_id: this.$route.params.idTest,
            quest_id: this.content[i].id,
            type: this.content[i].typePoint,
          };

        send
          .post('tests.php', data)
          .then((response) => {
            this.scoreInfo.maxScore -=

            this.content.splice(i, 1);
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });

      },

      openModal(){
        this.chooselesson = !this.chooselesson
      },

      // перепроверить все прохождения
      recheckThePasses() {
        let data = {
          module: 'md_rechecking_test',
          test_id: Number(this.$route.params.idTest),
        };

        console.log('md_rechecking_test', data);

        send
          .post('tests.php', data)
          .then((response) => {
            console.log('Успешно! Тестирование перепроверено!');
          })
          .catch((error) => {
            console.log('error!');
            console.log(error.response);
          });
        
      },

      // скачать файл
      downloadFile(item, event) {
        let path = event.path || (event.composedPath && event.composedPath());
        let checkEndFunction = false;

        for (let i = 0; i < path.length; i++) {

          if ((String(path[i].nodeName) === 'DIV') && path[i].className && (path[i].className.indexOf('file_delete') !== -1)) {
            checkEndFunction = true;
            break;
          }

        }

        if (!checkEndFunction) {
          console.log(item);
          let link = document.createElement('a');
          link.setAttribute('href', item.data.full_link);
          link.setAttribute('target', '_blank');
          // link.setAttribute('download', item.title);
          link.click();
        }
      },
    },

    computed: {
      getTaParamsForCheckbox() {
        return this.taParams.filter((item) => {
          if (item.id !== 2) return item
        })
      },

      getTaQuestionMaxId() {
        let maxId = -1;

        this.content.forEach((elem, j) => {
          if (elem.id > maxId) {
            maxId = elem.id;
          }
        });

        return maxId
      },
    },

    directives: {
      clickOutside: {
        bind(el, binding) {
          el.addEventListener('click', e => e.stopPropagation());
          document.body.addEventListener('click', binding.value);
        },
        unbind(el, binding) {
          document.body.removeEventListener('click', binding.value);
        }
      }
    },

    components: {
      addTest,
      HeaderComponent,
      FooterComponent,
      moduleLesson,
      draggable,
      Breadcrumbs,
      Editor,
      AddFiles,
      SlideUpDown
    }
  }
</script>

<style scoped lang="scss">
  @import "../../styles_fonts.scss";

  $font_Geometria: Geometria, 'Geometria';

  $color_background: #F6F6FB;
  $color_Gray_1: #C5C5C9;
  $color_Gray_2: #ABABB2;
  $color_Gray_3: #8D909F;
  $color_Gray_4: #EBEBEB;
  $color_Gray_5: #F2F2F2;
  $color_Gray_6: #8D909F;
  $color_Gray_7: #F9F9F9;
  $color_black: #333333;
  $color_purple: #8C71FE;
  $color_purple_2: #F2F1FF;
  $color_purple_3: #E2E2F6;
  $color_purple_4: #7B61EB;
  $color_purple_5: #6F57D6;
  $color_purple_6: #B1A1F2;
  $color_red: #FF6597;
  $color_green: #89CE54;
  $color_grey: #AEBCD6;
  $color_cyan: #C0CADC;
  $color_cyan_2: #AEBCD6;
  $color_cyan_3: #D1DBED;

  $color_whiteHover: #fafafa;

  $transition_medium: 0.5s ease;
  $transition_fast: 0.25s ease;

  $path_img_checkbox: '/lk/trialExams/img/save.svg';
  $path_img_checkbox_focus: '/lk/trialExams/img/checkImageCheckbox.svg';

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }

  .fadeFast-enter-active, .fadeFast-leave-active {
    transition: opacity .25s ease-in;
  }
  .fadeFast-enter, .fadeFast-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }

  .test {
    display: flex;
    flex-direction: column;
    width: 100%;

    .input_file__download {
      cursor: pointer;
    }
  }

  .test_component {
   /* display: flex;
    flex-direction: row;
    justify-content: space-between;*/
     display: grid;
     grid-template-columns: minmax(0, 2.2fr) minmax(0, 1fr);
     grid-gap: 28px;
    margin-top: 14px;
    font-family: $font_Geometria;
    color: $color_black;

    .file_title {
      max-height: none;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
  }

  /*.container:nth-child(1) {
    width: calc(70.5% - 24px);
  }

  .container:nth-child(2) {
    width: calc(29.5% - 24px);
  }*/

  .input_answer {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px 14px;
    background-color: $color_cyan_2;
    border-radius: 8px;
    margin: 6px 12px 6px 0;
  }

  .answer_text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    margin-right: 5px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #fff;
  }

  .answer_delete {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .test_component .elem_input__answer {
    cursor: default;
    height: auto;
    padding: 4px 20px;

    .input_svg {
      cursor: pointer;

      svg path {
        transition: $transition_medium;
      }

      &:hover {
        svg path {
          stroke: $color_purple;
          fill: $color_purple;
        }
      }
    }

    .answer_delete {
      cursor: pointer;
    }
  }

  .input_answerInput {

    input {
      height: 34px;
      width: 240px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 140%;
      outline: none;
      padding: 0 5px;
      border: none;
    }

    input::placeholder {
      color: $color_Gray_2;
    }
  }

  .default_input {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 20px;
    height: 54px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    cursor: text;
    transition: $transition_medium;
    font-size: 16px;
    line-height: 20px;
    font-weight: normal;
    outline: none;

    &:hover {
      border-color: $color_Gray_1;
    }

    &:focus {
      border-color: $color_purple;
    }
  }

  .folder {
    display: flex;
    flex-direction: column;
    padding: 26px 24px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    margin-bottom: 28px;
   /* position: sticky;
    top: calc(92px + 28px);*/

    .input_block {
      overflow: hidden;
    }
    .answer_delete {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .input_text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 10px;
      font-size: 16px;
      line-height: 20px;
      font-weight: normal;
    }

    .popup_element {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .folder_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: $color_Gray_2;
    margin-bottom: 8px;
  }

  .sidebar {
    display: flex;
    flex-direction: column;
    padding: 28px 6px 28px 24px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
   /* position: sticky;
    top: calc(92px + 28px);*/
  }

  .sidebar_list {
    display: flex;
    flex-direction: column;
    max-height: 36vh;
    overflow: auto;
    padding-right: 18px;
  }

  .sidebar_list::-webkit-scrollbar {
    width: 4px;               /* ширина scrollbar */
    cursor: default !important;
  }

  .sidebar_list::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0);        /* цвет дорожки */
    border-radius: 4px 0 0 4px;
    overflow: hidden;
    cursor: default !important;
  }

  .sidebar_list::-webkit-scrollbar-thumb {
    background-color: $color_cyan;    /* цвет плашки */
    border-radius: 3px;       /* закругления плашки */
    cursor: default !important;
  }

  .list_elem {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .list_elem:not(:first-child) {
    margin-top: 22px;
  }

  .elem_num {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-color: $color_Gray_5;
    color: $color_Gray_1;
    min-width: 24px;
    min-height: 24px;
    width: 24px;
    height: 24px;
    margin-right: 10px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }

  .list_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #C0CADC;
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
    border-radius: 50%;
    transition: $transition_medium;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    color: #fff;
  }

  .list_icon__active {
    background-color: $color_green;
    border: 2px solid $color_green;
  }

  .list_icon_svg {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list_title {
    margin-left: 12px;
    white-space: nowrap; /* Отменяем перенос текста */
    overflow: hidden; /* Обрезаем содержимое */
    text-overflow: ellipsis; /* Многоточие */
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }

  .sidebar_border {
    display: flex;
    flex-direction: column;
    height: 1px;
    background-color: $color_Gray_4;
    margin: 28px 18px 28px 0;
  }

  .sidebar_buttons .sidebar_button:not(:first-child) {
    margin-top: 18px;
  }

  .sidebar_button {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 12px;
    height: 44px;
    border: 2px solid $color_purple;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    transition: $transition_medium;
    cursor: pointer;
    margin-right: 18px;
  }

  .sidebar_button__theme_purple {
    color: #fff;
    background-color: $color_purple;

    &:hover {
      background-color: $color_purple_4;
      border-color: $color_purple_4;
      color: white;
    }
  }

  .sidebar_button__theme_white {
    color: $color_purple;

    &:hover {
      background-color: $color_purple;
      border-color: $color_purple;
      color: white;
    }
  }


  .task {
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
  }

  .task:not(:first-child) {
    margin-top: 28px;
  }

  .task_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 20px 26px 18px 26px;
  }

  .header_title {
    text-transform: uppercase;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    white-space: nowrap; /* Отменяем перенос текста */
    overflow: hidden; /* Обрезаем содержимое */
    text-overflow: ellipsis; /* Многоточие */
    margin-right: 60px;
    color: $color_black;
  }

  .header_buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header_button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .header_button:not(:first-child) {
    margin-left: 24px;
  }

  .task_border {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.08);
  }

  .task_main {
    display: flex;
    flex-direction: column;
    margin: 22px 26px 26px 26px;
  }

  .task_block {
    display: flex;
    flex-direction: column;
  }

  .task_block:not(:first-child) {
    margin-top: 28px;
  }

  .task_row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
  }

  .task_elem {
    display: flex;
    flex-direction: column;
  }

  .elem_title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: $color_Gray_1;
    margin-bottom: 5px;
  }

  .elem_input {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: calc(100% - 40px);
    padding: 0 20px;
    min-height: 54px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    cursor: pointer;
    transition: $transition_medium;

    svg path {
      transition: $transition_medium;
    }

    &:hover {
      border: 1px solid $color_Gray_1;

      .input_image svg path {
        fill: $color_Gray_1;
      }
    }
  }

  .input_popup {
    position: absolute;
    top: 0;
    left: 0;
    width: 260px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
    border-radius: 8px;
    padding: 11px 0;
    z-index: 5;
    max-height: 300px;
    overflow: auto;
  }

  .input_popup::-webkit-scrollbar {
    width: 4px;               /* ширина scrollbar */
    cursor: default !important;
  }

  .input_popup::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0);        /* цвет дорожки */
    border-radius: 4px 0 0 4px;
    overflow: hidden;
    cursor: default !important;
  }

  .input_popup::-webkit-scrollbar-thumb {
    background-color: $color_cyan;    /* цвет плашки */
    border-radius: 3px;       /* закругления плашки */
    cursor: default !important;
  }


  .popup_element {
    padding: 9px 24px;
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    color: $color_black;
    transition: $transition_medium;
  }

  .popup_element:hover {
    color: $color_purple;
  }

  .popup_element__active {
    color: $color_purple;
  }

  .input_block {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
  }

  .input_image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100%);
    transition: $transition_medium;
  }

  .input_image__active {
    transform: rotate(180deg);
  }

  .input_svg {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input_placeholder {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    color: $color_Gray_2;
    padding-right: 40px;
  }

  .input_block {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
  }

  .input_files {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 0;
  }

  .input_file {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 260px;
    height: 34px;
    padding: 0 14px;
    border-radius: 8px;
    background-color: $color_purple;
    cursor: default;
  }

  .input_file:not(:first-child) {
    margin-top: 10px;
  }

  .input_file_test {
    width: 700px;
  }

  .file_title {
    padding-right: 20px;
    white-space: nowrap; /* Отменяем перенос текста */
    overflow: hidden; /* Обрезаем содержимое */
    text-overflow: ellipsis; /* Многоточие */
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #fff;
  }

  .file_delete {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .task_input {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    border: 1px solid $color_Gray_4;
  }

  .input_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: $color_Gray_7;
    height: 40px;
    padding: 0 16px;
  }

  .header_component {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: $transition_medium;
  }

  .header_item:not(:first-child) {
    margin-left: 10px;
  }

  .header_item_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: $transition_medium;
    height: 24px;

    svg path {
      transition: $transition_medium;
    }
  }

  .header_item__color {
    &:hover {
      svg path {
        fill: $color_purple;
      }
    }
  }

  .header_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: $transition_medium;
    cursor: pointer;

    svg path {
      transition: $transition_medium;
    }

    &:hover {
      svg path {
        fill: $color_purple;
      }
    }
  }

  .header_icon__active {
    svg path {
      fill: $color_purple;
    }
  }

  .header_border {
    display: flex;
    height: 100%;
    width: 1px;
    background-color: $color_Gray_4;
    margin: 0 15px;
  }

  .icon_color {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 16px;
    height: 16px;
    background-color: black;
  }

  .input_main {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 0 14px 18px;
    position: relative;
    cursor: text;
  }

  .custom_input {
    width: 100%;
    padding-right: 48px;
    min-height: 80px;
    max-height: 160px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    color: $color_black;
    font-family: $font_Geometria;
    overflow: auto;
    outline: none;
    word-break: break-all;
    scrollbar-width: thin;
    scrollbar-color: $color_cyan rgba(255, 255, 255, 0);
  }

  .custom_input[contenteditable=true]:empty:before {
    content: attr(placeholder);
    pointer-events: none;
    display: block;
    color: $color_Gray_2;
  }

  .custom_input::-webkit-scrollbar {
    width: 4px; /* ширина scrollbar */
    cursor: default !important;
  }

  .custom_input::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0); /* цвет дорожки */
    border-radius: 4px 0 0 4px;
    overflow: hidden;
    cursor: default !important;
  }

  .custom_input::-webkit-scrollbar-thumb {
    background-color: $color_cyan; /* цвет плашки */
    border-radius: 3px; /* закругления плашки */
    cursor: default !important;
  }

  .smile_component {
    position: absolute;
    right: 38px; // 24px + 14px
    bottom: 14px;
    cursor: pointer;
  }

  .deadline_container {
    display: flex;
    flex-direction: row;
    width: calc(100% - 40px);
    height: 54px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    cursor: pointer;
    transition: $transition_medium;

    svg path {
      transition: $transition_medium;
    }

    &:hover {
      border: 1px solid $color_Gray_1;

      svg path {
        fill: $color_Gray_1;
      }
    }
  }

  .deadline_time {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    padding: 0 20px;

    input {
      width: 68px;
      border: none;
      padding: 0;
    }

    input:hover {
      border: none;
    }

    input:focus {
      border: none;
    }

    .deadline_svg {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 20px;
      cursor: text;
    }
  }

  .deadline_border {
    display: flex;
    height: 100%;
    width: 1px;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.08);
  }

  .deadline_date {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .task_footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .task_params {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .task_param {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 10px;
  }

  .task_param:not(:last-child) {
    margin-right: 26px;
  }

  .task_checkbox {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  .task_checkbox + label {
    display: inline-flex;
    align-items: center;
    user-select: none;
    cursor: pointer;
    color: $color_Gray_1;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    transition: $transition_medium;
  }
  .task_checkbox + label::before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1px solid $color_Gray_4;
    border-radius: 4px;
    margin-right: 10px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    transition: $transition_medium;
  }

  .task_checkbox:hover + label {
    color: $color_purple;
  }

  .task_checkbox:hover + label::before {
    border-color: $color_purple;
  }

  .task_checkbox:checked + label::before {
    border-color: $color_purple;
    background-color: $color_purple;
    background-image: url($path_img_checkbox_focus);
  }

  .task_checkbox:checked + label {
    color: $color_purple;
  }

  .score {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      color: $color_black;
    }

    input::placeholder {
      color: $color_Gray_1;
    }
  }

  .score_text {
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    color: $color_Gray_1;
    margin-right: 10px;
    white-space: nowrap;
  }

  .input_score {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 40px;
    border: 1px solid $color_Gray_4;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    outline: none;
    transition: $transition_medium;
  }

  .task_buttons {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 22px;
    padding: 24px 40px;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
  }

  .task_buttons__margin {
    margin-top: 28px;
  }

  .task_button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    padding: 20px 0 14px 0;
    border-radius: 8px;
    background-color: $color_background;
    cursor: pointer;
    transition: $transition_medium;
    color: $color_purple_6;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    cursor: pointer;

    svg {
      transition: $transition_medium;
    }

    svg path {
      transition: $transition_medium;
    }

    svg rect {
      transition: $transition_medium;
    }
  }

  .task_button:hover {
    background-color: $color_purple_2;
  }

  .button_svg {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
  }

  .button_text {
    margin-top: 6px;
  }

  // модальные окна выбора цвета и типа списка
  .modal_list {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    background-color: white;
    padding: 20px;
  }

  .modal_item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid $color_Gray_1;
    background-color: $color_Gray_5;
    transition: $transition_medium;
  }

  .modal_item:not(:first-child) {
    margin-left: 12px;
  }

  .modal_item__list {
    color: $color_Gray_2;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;

    &:hover {
      border: 1px solid $color_purple;
      color: $color_purple;
      background-color: $color_purple_2;

      .modal_dot {
        background-color: $color_purple;
      }
    }
  }

  .modal_item__list_active {
    border: 1px solid $color_purple;
    color: $color_purple;
    background-color: $color_purple_2;

    .modal_dot {
      background-color: $color_purple;
    }
  }

  .modal_dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: $color_Gray_2;
    transition: $transition_medium;
  }

  .modal_item__color {
    position: relative;
    overflow: hidden;
  }

  .modal_item__color::after {
    content: '';
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    transition: $transition_medium;
  }

  .modal_item__color:hover::after {
    background-color: rgba(0, 0, 0, 0.10);
  }

  .modal_item__color_black {
    background-color: $color_black;
    border: 1px solid $color_black;
  }

  .modal_item__color_purple {
    background-color: $color_purple;
    border: 1px solid $color_purple;
  }

  .modal_item__color_green {
    background-color: $color_green;
    border: 1px solid $color_green;
  }

  .modal_item__color_red {
    background-color: $color_red;
    border: 1px solid $color_red;
  }

  .icon_color__black {
    background-color: $color_black;
  }

  .icon_color__purple {
    background-color: $color_purple;
  }

  .icon_color__green {
    background-color: $color_green;
  }

  .icon_color__red {
    background-color: $color_red;
  }

  .task {
    .task_list {
      display: flex;
      flex-direction: column;
    }

    .list_block {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 24px;
      grid-gap: 16px;
      align-items: center;
    }

    .list_block:not(:first-child) {
      margin-top: 10px;
    }

    .list_elem {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      padding: 0 20px;
      height: 54px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      transition: $transition_medium;
    }

    .list_elem:hover {
      border: 1px solid $color_Gray_1;
    }

    .list_elem__active {
      border: 1px solid $color_purple;

      &:hover {
        border: 1px solid $color_purple;
      }
    }

    .list_elem:not(:first-child) {
      margin-top: 10px;
    }

    .list_title {
      color: $color_cyan_2;
    }
  }

  .move_button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: $transition_medium;

    svg path {
      transition: $transition_medium;
    }

    &:hover {
      svg path {
        fill: #ABABB2;
      }
    }
  }

  .elem_block {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    label {
      width: 100%;
    }

    .input__text {
      height: 52px;
      width: calc(100% - 50px);
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 140%;
      font-family: $font_Geometria;
      color: $color_black;
      outline: none;
      border: none;
    }

    .input__text::placeholder {
      color: $color_Gray_2;
    }
  }

  .elem_basket {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: $transition_medium;
    cursor: pointer;

    svg path {
      transition: $transition_medium;
    }

    &:hover {
      svg path {
        fill: $color_purple;
      }
    }
  }

  .custom-checkbox, .custom-radio {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }

  .custom-checkbox+label, .custom-radio+label {
    display: inline-flex;
    align-items: center;
    user-select: none;
  }
  .custom-radio+label::before {
    content: '';
    display: inline-block;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    margin-right: 10px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 80% 80%;
    transition: $transition_medium;
    cursor: pointer;
  }

  .custom-checkbox+label::before {
    content: '';
    display: inline-block;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    flex-grow: 0;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    margin-right: 10px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 80% 80%;
    transition: $transition_medium;
    cursor: pointer;
  }


  .custom-checkbox:checked+label::before {
    border-color: $color_purple;
    background-color: $color_purple;
    background-image: url($path_img_checkbox_focus);
  }

  .custom-radio:checked+label::before {
    border-color: $color_purple;
    background-color: $color_purple;
    background-image: url($path_img_checkbox_focus);
  }

  .list_button {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 0 20px;
    height: 54px;
    border: 1px solid $color_cyan_3;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.5s ease;
  }

  .list_svg {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list_title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }

  .header_breadcrumb {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .delete_button {
    margin-left: 40px;
    cursor: pointer;
    transition: $transition_medium;
    color: $color_red;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    font-family: $font_Geometria;

    &:hover {
      text-decoration: underline;
    }
  }

  .score_container {
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    border-radius: 16px;
    margin-bottom: 28px;
  }

  .score_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 66px;
  }

  .score_title {
    text-transform: uppercase;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 140%;
    color: $color_cyan_2;
  }

  .score_border {
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.08);
  }

  .score_body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
    grid-gap: 14px;
    align-items: center;
    padding: 24px;


    .input_score_percent {
      padding: 0 46px 0 16px;
    }

    .input_score {
      padding: 0 74px 0 16px;
    }

    .score_text {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: $color_Gray_2;
      transition: $transition_medium;
      margin: 0;
    }

    .score_input__background {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 16px;
    }

    .score_svg {
      svg path {
        transition: $transition_medium;
      }
    }
  }

  .input_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;

    input[type='number'] {
      -moz-appearance:textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      height: 54px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      outline: none;
      font-family: $font_Geometria;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      transition: $transition_medium;
      text-align: start;
    }

    input:hover {
      border-color: $color_Gray_2;
    }

    input:focus {
      border-color: $color_purple;
    }

    input::placeholder {
      font-family: $font_Geometria;
      color: $color_Gray_2;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
    }

    input:focus + .score_svg {
      svg path {
        fill: $color_purple;
      //  stroke: $color_purple;
      }
    }

    input:focus + .score_text {
      color: $color_purple;
    }

  }


</style>